import React, { Component } from "react";
import { getStatusBarHeight } from "react-native-status-bar-height";
import AccessControl from "../components_v2/AccessControl";
import AirConditionerThermostat from "../components_v2/AirConditionerThermostat";
import AppLoading from "../components/Loading";
import Area from "../components_v2/Area";
import { IconButton } from "../components_v2/Buttons";
import ElevatorPanel from "../components_v2/ElevatorPanel";
import { WARNING_MIN_BATTERY } from "../../assets/consts";
import RBSheet from "../modules/RNBottomSheet"; //"react-native-raw-bottom-sheet";
import MediaPlayerList from "../components/MediaPlayerList";
import {
  View,
  Text as TextReactNative,
  ScrollView,
  Dimensions,
  StyleSheet,
  RefreshControl,
  Image,
  SafeAreaView,
  BackHandler,
  TouchableOpacity,
} from "react-native";
import Text from "../components_v2/TextFont";
import ArButton from "../argon-ui/Button";
import { connect } from "react-redux";
import { IS_MOBILE, IS_WEB, translate } from "../locales/translate";

import * as CONSTANTS from "../../assets/consts";
import * as SecureStore from "../components_v2/DeviceAsyncStorage";
import * as DeviceTypes from "../components/devices/_deviceTypes";
import * as AreaTypes from "../components/areas/_areaType";

import * as UserActions from "../actions/UserActions";
import * as AppActions from "../actions/AppActions";
import * as AccessControlActions from "../actions/AccessControlActions";
import * as LightActions from "../actions/LightActions";
import * as ElevatorsAction from "../actions/ElevatorActions";
import * as WateringSwitchAction from "../actions/WateringSwitchActions";
import * as OutletActions from "../actions/OutletActions";
import * as SirenActions from "../actions/SirenActions";
import * as AirConditionerActions from "../actions/AirConditionerActions";
import * as DeviceActions from "../actions/DeviceActions";
import * as SmartSpeakerActions from "../actions/SmartSpeakerActions";
import * as PowerSwitchActions from "../actions/PowerSwitchActions";
import * as DoorlockActions from "../actions/DoorlockActions";
import * as CurtainActions from "../actions/CurtainActions";
import * as AreaActions from "../actions/AreaActions";

import IPCameraHelper from "../modules/cameraHelper/IPCameraHelper";
import Curtain from "../components_v2/Curtain";
import BottomNavigation, {
  Badge,
  IconTab,
} from "react-native-material-bottom-navigation";
import Theme from "../argon-ui/Theme";
import * as faCharCodes from "../../assets/consts/faCharCodes";
import { Platform } from "react-native";
import ShortcutBoard from "../components_v2/ShortcutBoard";
import WidgetContainer from "../components_v2/widgets/WidgetContainer";
import * as CONSTS from "../../assets/consts";
import CacheStorage from "../modules/cacheStorage";
import LowBatteryMessage from "../components_v2/LowBatteryMessage";
import UserProfile from "../components/UserProfile";
import DeviceInfoHandler from "../modules/deviceInfo/DeviceInfoHandler";

// === components ===
import MenuBarSectionComponents from "../components/homeScreen/MenuBarSectionComponents";
import DoorLock from "../components/DoorLock";
import AreaKiosk from "../components_v2/AreaKiosk";

// === RbSheet ===
import RBSheetInner from "../components_v2/RBSheet/RBSheetInner";

// === Models ===
import AreaModel from "../viewModels/AreaModel";
import RBSheetInnerDeviceItem from "../components_v2/RBSheet/RBSheetInnerDeviceItem";
import RBSheetInnerBatchAction from "../components_v2/RBSheet/RBSheetInnerBatchAction";
import RBSheetInnerSettingItem from "../components_v2/RBSheet/RBSheetInnerSettingItem";
import RBSheetInnerAreaState from "../components_v2/RBSheet/RBSheetInnerAreaState";
import useAreaListByAreaType from "../components/areas/useAreaListByAreaType";
import {
  Center,
  Divider,
  HStack,
  Toast as ToastBase,
  Collapse,
  VStack,
  Modal,
} from "native-base";
import Menu from "../components_v2/Menu/Menu";
import AreaItemSkeleton from "../nativeBase-ui/skeleton/AreaItemSkeleton";
import AreaKioskItemSkeleton from "../nativeBase-ui/skeleton/AreaKioskItemSkeleton";
import fetchUserBuildings from "../hooks/fetchUserBuildings";
import MessageBox from "../components_v2/MessageBox";
import ToastAlert from "../nativeBase-ui/ToastAlert";
import ModalJoinBuilding from "../components_v2/ModalJoinBuilding";
import { connectToBuilding } from "../hooks/connectToServer/connectToBuilding";
import { onFirebaseHandler } from "../modules/firebaseHandler/onFirebaseHandler";
import QRCodeJoinBuilding from "../components_v2/QRCodeJoinBuilding";
import MenuDrawer from "../components_v2/Menu/MenuDrawer";
import AlertDialogBase from "../nativeBase-ui/AlertDialog";
import ModalBase from "../nativeBase-ui/ModalBase";
import AppWidgetAnnouncement from "../components/AppWidgetAnnouncement";
import PinCodeArm from "../components_v2/PinCodeArm";
import { getIconByDeviceType } from "../actions/DeviceHelper";
// import { updateDeviceAvailable } from "../util/updateDeviceAvailable";
// import Weather from "../components_v2/Weather";

import { Audio } from "expo-av";
import { getDir, getIsRTL } from "../util";
// import MjpegPlayerComponent from "../components/MjpegPlayerComponent";

const HEIGHT = Dimensions.get("screen").height;
const HEIGHT_W = Dimensions.get("window").height;
const WIDTH = Dimensions.get("window").width;
// === height Status Bar ===
const HEIGHT_STATUS_BAR = getStatusBarHeight();
const RB_SHEET_HEIGHT = HEIGHT * 0.65;
const RB_SHEET_WIDTH = WIDTH / 3.2;
const RB_SHEET_TITLE_HEIGHT = 60;

const typeLogoWidth = IS_WEB
  ? Math.min(CONSTS.WEB_MAX_WIDTH, WIDTH) / 3
  : WIDTH / 4;
const typeLogoHeight = typeLogoWidth / 3.5;

const SensorDeviceTypes = [
  DeviceTypes.MOTION_SENSOR,
  DeviceTypes.LIGHT_METER,
  DeviceTypes.THERMO_METER,
  DeviceTypes.HUMIDITY_SENSOR,
  DeviceTypes.DOOR_SENSOR,
  DeviceTypes.LEAK_DETECTOR,
  DeviceTypes.SMOKE_DETECTOR,
  DeviceTypes.SENSOR_BINARY,
  DeviceTypes.VOLTAGE_SENSOR,
];
class HomeScreen extends Component {
  constructor(props) {
    super(props);
    this.player = undefined;
    this.AreasRef = [];
    this.state = {
      accessToken: null,
      activeTab: "home",
      activeModal: false,
      activeModalTitle: null,
      selectedAreaId: 0,
      selectedAreaUId: 0,
      selectedAreaName: "",
      selectedCameraId: undefined,
      selectedAreaDeviceType: "",
      selectedAreaTypeItem: "",
      serverUrl: "",
      accountDisplayName: "",
      isShowingUnlockDoorAlert: false,
      doorToUnlockDeviceId: undefined,
      doorToUnlockDeviceUId: undefined,

      isShowingAccessControlOpenDoorConfirm: undefined,
      accessControlToOpenDoorDeviceId: undefined,
      accessControlToOpenDoorDeviceUId: undefined,
      accessControlToOpenDoorDeviceName: undefined,
      isShowingAccessControlOpenAllAreaDoorsConfirm: undefined,
      accessControlToOpenAllDoorsAreaId: undefined,
      accessControlToOpenAllDoorsAreaUId: undefined,

      isShowingAccessControlAcknowledgement: undefined,
      accessControlAcknowledgementToConfirmEventId: undefined,
      accessControlAcknowledgementToConfirmDeviceName: undefined,
      accessControlAcknowledgementToConfirmEventCode: undefined,
      accessControlAcknowledgementToConfirmPersianDate: undefined,

      isShowingUserSessionsWarning: true,

      isPlayingAlarm: null,
      alarmSound: null,

      hasNewUpdate: false,
      rbSheetTitle: "",
      waitingForAreaToLoad: true,
      sirenToTurnOn: {
        showConfirm: false,
        sirenDeviceId: 0,
        sirenDeviceUId: null,
        sirenDeviceName: "",
        areaId: 0,
        areaUId: null,
        value: false,
      },
      showModalForElevator: false,
      selectedElevator: null,
      selectedElevatorUId: null,
      currentFloor: undefined,
      userFloor: null,
      isRefreshing: false,
      isShowingCancelAlert: true,
      showAreaState: false,
      selectedArea: null,
      selectedSmartSpeakerDeviceId: undefined,
      selectedSmartSpeakerDeviceUId: undefined,
      selectedPlayListId: 0,
      selectedPlayListUId: "",
      areaStateIdToChange: null,
      areaStateUIdToChange: null,
      areaStateNameToChange: null,
      areaStateActionToChange: null,
      isShowChangeAreaStateConfirm: false,
      armStateId: "Arm",
      playListIdToDelete: 0,
      playListUIdToDelete: null,
      playListTitleToDelete: "",
      // === Kiosk mode ===
      isKioskMode: false,
      selectAreaItem: null,
      // === BackHandler ===
      validCloseWindow: false,
      // === Building Handler ===
      showJoinModal: false,
      showQRCodeJoinBuilding: false,
      selectedJoinBuildingInfo: null,
      showMenuDrawer: false,
      appWidgetAnnouncementMessage: null,
      deviceList: [],
    };
  }

  componentDidUpdate() {
    this.updateAccessToken();
    if (
      this.props.AppReducer.announcement !==
      this.state.appWidgetAnnouncementMessage
    ) {
      this.setState({
        appWidgetAnnouncementMessage: this.props.AppReducer.announcement,
      });
    }
    // this.setState({isPlayingAlarm: this.props.AreaReducer.isPlayingAlarm});
    this.props.AreaReducer.isPlayingAlarm && this.playAlarm();
    !this.props.AreaReducer.isPlayingAlarm && this.stopAlarm();
  }
  // === Kiosk Mode ===
  KioskMode() {
    var devInfo = new DeviceInfoHandler();
    let isKioskMode = devInfo.isKioskMode();
    this.props.updateKioskMode(isKioskMode);
    this.setState({
      isKioskMode,
    });
  }
  updateAccessToken() {
    const accessToken = this.props.AppReducer?.currentServer.accessToken;
    if (accessToken !== this.state.accessToken) {
      this.setState({ accessToken }, () => {
        this.props.appWidgetAnnouncement(accessToken);
      });
    }
  }
  async componentDidMount() {
    this.updateAccessToken();
    // === kiosk mode ===
    this.KioskMode();
    Dimensions.addEventListener("change", () => this.KioskMode());

    this.loadQuickAccessFromCache();

    const currentBuilding = this.props.AppReducer.currentBuilding;
    if (currentBuilding && Object.keys(currentBuilding).length > 0) {
      const access_token = await SecureStore.Servers.getAccessToken(
        currentBuilding.serverId
      );
    }

    setTimeout(() => {
      this.setState({ waitingForAreaToLoad: false });
    }, 10000);

    // === BackHandler ===
    BackHandler.addEventListener("hardwareBackPress", this.handleBackButton);
    
    // AccessControl Camera Closing Interval
    // setInterval(() => {
    //   var now = new Date();
    //   var msdif =
    //     new Date() -
    //     this.props.DeviceReducer.list.find(
    //       (d) =>
    //         d.deviceUId == this.props.DeviceReducer.isShowingAccessControlNotification
    //     ).accessControlCameraStartTime;

    //   // Check old camera
    //   if (msdif >= 20000) {
    //     this.hideAccessControlNotification(
    //       this.props.DeviceReducer.list.find(
    //         (d) =>
    //           d.deviceUId ==
    //           this.props.DeviceReducer.isShowingAccessControlNotification
    //       ).accessControlCameraProcessId
    //     );
    //   }
    // }, 10000);
  }

  componentWillUnmount() {
    BackHandler.removeEventListener("hardwareBackPress", this.handleBackButton);
  }
  handleBackButton = () => {
    if (this.props.navigation.isFocused()) {
      if (this.state.validCloseWindow) {
        BackHandler.exitApp();
        return true;
      }

      this.setState({ validCloseWindow: true });
      setTimeout(() => {
        this.setState({ validCloseWindow: false });
      }, 3000);
      const toastDetail = {
        title: translate("app.backButtonPress"),
        variant: "subtle",
        status: "info",
      };
      ToastBase.show({
        duration: 2000,
        render: () => {
          return <ToastAlert {...toastDetail} />;
        },
      });
      // ToastAndroid.show("Press Again To Exit !", ToastAndroid.SHORT);
      return true;
    }
    return false;
  };

  loadQuickAccessFromCache = async (buildingId = "") => {
    var cacheStorage = new CacheStorage();
    if (!buildingId) {
      var activeProfile = this.props.AppReducer.currentBuilding;
      if (activeProfile && activeProfile.buildingId)
        buildingId = activeProfile.buildingId;
    }
    // scenarios
    var scenarios = await cacheStorage.QuickAccess.GetScenarioQuickAccess(
      buildingId
    );
    if (Array.isArray(scenarios)) {
      var scenarioModels = scenarios.map((s) => {
        // generate fake scenario-ish objects to show correct item in shortcut board
        return {
          id: s.id,
          uId: s.uId,
          name: s.name,
          _mainConditionType: "virtual",
          showDashboardShortcut: true,
          conditions: [
            {
              iconName: s.icon,
              isMain: true,
              baseType: "virtual",
            },
          ],
        };
      });
      this.props.setScenariosFromCache(scenarioModels);
    }

    var areas = await cacheStorage.Areas.GetAll(buildingId);

    this.props.areaCache(areas);
    // console.log(`areas quick access`, areas);

    // var devices = await cacheStorage.QuickAccess.GetUserQuickAccess();
    // console.log(`device quick access`, devices);
  };

  playAlarm = async () => {
    if (this.state.alarmSound == null) {
      // console.log("Playing Alarm");
      try {
        const { sound } = await Audio.Sound.createAsync(
          require("../../assets/alarm1.mp3")
        );
        this.setState({ alarmSound: sound });
        await this.state.alarmSound.playAsync();
        await this.state.alarmSound.setIsLoopingAsync(true);
      } catch (error) {
        // console.log(error);
      }
    }
  };
  stopAlarm = async () => {
    if (this.state.alarmSound != null) {
      // console.log("Stopping Alarm");
      try {
        await this.state.alarmSound.stopAsync();
        await this.state.alarmSound.unloadAsync(true);
        this.state.alarmSound = null;
      } catch (error) {
        // console.log(error);
      }
    }
  };

  renderIcon =
    (icon, size) =>
    ({ isActive }) =>
      (
        <View
          style={{
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <View
            style={{
              width: (size || 15) * 2,
              height: (size || 15) * 2,
              borderRadius: 5,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <TextReactNative
              style={{
                fontFamily: faCharCodes.FONT_FAMILIES.PRO_REGULAR,
                fontSize: size || 15,
                color: Theme.COLORS.DARK,
                position: "absolute",
              }}
            >
              {icon}
            </TextReactNative>
          </View>
        </View>
      );

  renderTab = ({ tab, isActive }) =>
    tab.hide ? (
      <Text /> // empty text if should hide
    ) : (
      <IconTab
        showBadge={
          (tab.key == "setting" && this.state.hasNewUpdate) ||
          (tab.key == "setting" &&
            this.props.UserMessageReducer.newUserMessages > 0) ||
          (tab.key == "setting" && this.checkBadgeNoAreaUsers())
          // ||(tab.key == "setting" && this.checkBadgeUpdateDeviceController())
        }
        renderBadge={() => {
          return (
            <Badge
              style={{
                width: 8,
                minWidth: 8,
                height: 8,
              }}
            />
          );
        }}
        isActive={isActive}
        key={tab.key}
        label={tab.label}
        renderIcon={this.renderIcon(tab.icon, tab.size)}
      />
    );

  handleOnBottomNavigationTabPress = (newTab) => {
    this.setState({ activeTab: newTab.key.replace("home", "profiles") }); // "home" is used for default list(devices list). use profiles instead
    switch (newTab.key) {
      case "setting":
        this.setState({ showMenuDrawer: true });
        break;
      case "ordersList":
        this.showActiveModal("ordersList");
        break;
      case "scenarios":
        this.props.navigation.navigate("Scenarios");
        break;
      case "home":
        this.refreshData(this.props.AppReducer.currentBuilding?.buildingId);
        break;
      default:
        console.log("bottom tab", newTab.key, "not handled");
        break;
    }
  };

  handleOnServerChanged = async (
    serverInfo,
    addressConnected = null,
    building = null
  ) => {
    if (serverInfo) {
      let { accessToken, publicAddress } = serverInfo;
      let address = addressConnected || publicAddress;
      if (!accessToken) {
        this.props.navigation.replace("Login");
        return;
      }
      this.props.reconnect(address);
      this.props.updateCurrentServer(serverInfo);
      this.setState({
        waitingForAreaToLoad: true,
        serverUrl: address,
      });
      await SecureStore.setItemAsync(CONSTS.ACCESS_TOKEN, accessToken);
      if (building) {
        this.props.updateCurrentBuilding(building);
        const { buildingId, buildingName } = building;
        await SecureStore.setBuildingId(buildingId);
        this.setState(
          {
            accountDisplayName: `${buildingName}`,
            isRefreshing: true,
            waitingForAreaToLoad: true,
          },
          () => {
            this.props.clearCache();
            onFirebaseHandler(this.props.dispatch, accessToken);
            this.props.forceInit(accessToken, buildingId);
          }
        );
        this.loadQuickAccessFromCache(buildingId);
        setTimeout(() => {
          this.setState({ isRefreshing: false, waitingForAreaToLoad: false });
        }, 7000);
      }
    }
  };
  // handleOnBuildingChanged = async (building) => {
  //   if (building) {
  //     // === Change building without change server ===
  //     if (
  //       this.props.AppReducer?.currentServer.serverId == building?.serverId ||
  //       this.props.AppReducer?.currentServer.serverId == building?.cloudServerId
  //     ) {
  //       if (
  //         building.buildingId !==
  //         this.props.AppReducer?.currentBuilding.buildingId
  //       ) {
  //         this.hideActiveModal();
  //         this.refreshData(building.buildingId);
  //         this.props.updateCurrentBuilding(building);
  //       }
  //     } else {
  //       this.hideActiveModal();
  //       // === Change building with change server ===
  //       let { buildingId } = building;
  //       const serverInfo = await connectToBuilding(buildingId);
  //       const findServer = this.props.AppReducer.servers.find(
  //         (server) => server.serverId === serverInfo?.serverInfo.serverId
  //       );
  //       if (serverInfo && findServer) {
  //         this.props.updateServerUrl(serverInfo.address);
  //         this.handleOnServerChanged(findServer, serverInfo.address, building);
  //       } else {
  //         const message = {
  //           title: translate("serverList.errors.ServerError"),
  //           variant: "top-accent",
  //           status: "error",
  //           duration: 2500,
  //         };
  //         this.props.messageToast(message);
  //       }
  //     }
  //   }
  // };
  handleOnBuildingChanged = async (building) => {
    if (building) {
      this.hideActiveModal();
      // === Change building without change server ===
      if (
        this.props.AppReducer?.currentServer.serverId == building?.serverId ||
        this.props.AppReducer?.currentServer.serverId == building?.cloudServerId
      ) {
        this.refreshData(building.buildingId);
        this.props.updateCurrentBuilding(building);
      } else {
        // === Change building with change server ===
        let { buildingId } = building;
        const serverInfo = await connectToBuilding(buildingId);
        const findServer = this.props.AppReducer.servers.find(
          (server) => server.serverId === serverInfo?.serverInfo.serverId
        );
        if (serverInfo && findServer) {
          this.props.updateServerUrl(serverInfo.address);
          this.handleOnServerChanged(findServer, serverInfo.address, building);
        } else {
          const message = {
            title: translate("serverList.errors.ServerError"),
            variant: "top-accent",
            status: "error",
            duration: 2500,
          };
          this.props.messageToast(message);
        }
      }
    }
  };

  getDeviceListByType = (deviceType, areaUId) => {
    var _devices = [];
    for (var a in this.props.AreaReducer.areas) {
      let area = this.props.AreaReducer.areas[a];
      if (
        area &&
        ((typeof areaUId === "string" && area.areaUId == areaUId) ||
          area.areaId == areaUId)
      ) {
        if (
          deviceType == DeviceTypes.POWER_METER ||
          deviceType == DeviceTypes.WATER_METER
        ) {
          if (area.relatedAreaPowerMeterId) {
            _devices.push({
              deviceId: area.relatedAreaPowerMeterId,
              deviceUId: area.relatedAreaPowerMeterUId,
              deviceName: translate("v2Dashboard.PowerMeter"),
              deviceType: DeviceTypes.POWER_METER,
            });
          }
          if (area.relatedAreaWaterMeterId) {
            _devices.push({
              deviceId: area.relatedAreaWaterMeterId,
              deviceUId: area.relatedAreaWaterMeterUId,
              deviceName: translate("v2Dashboard.WaterMeter"),
              deviceType: DeviceTypes.WATER_METER,
            });
          }

          return _devices;
        }
        for (var d in this.props.DeviceReducer.list) {
          let dvc = this.props.DeviceReducer.list[d];
          // doorbells must be get list of cameras connected to doorLock
          if (deviceType == DeviceTypes.DOORBELL) {
            // is CAMERA (belongs to area) and connected to doorLock
            if (
              (area.uDevices?.includes(dvc.deviceUId) ||
                area.devices?.includes(dvc.deviceId)) &&
              dvc.deviceType == DeviceTypes.CAMERA &&
              (dvc.doorLockDeviceId || dvc.doorLockDeviceUId)
            ) {
              _devices.push(dvc);
            }
          }
          // else is camera, only get cameras without doorlock connected
          else if (deviceType == DeviceTypes.CAMERA) {
            if (
              (area.uDevices?.includes(dvc.deviceUId) ||
                area.devices?.includes(dvc.deviceId)) &&
              dvc.deviceType == DeviceTypes.CAMERA
              // && !dvc.doorbellDeviceId
            ) {
              _devices.push(dvc);
            }
          } else if (deviceType == DeviceTypes.AIR_CONDITIONER) {
            if (
              (area.uDevices?.includes(dvc.deviceUId) ||
                area.devices?.includes(dvc.deviceId)) &&
              dvc.deviceType == DeviceTypes.AIR_CONDITIONER &&
              !dvc.statusRelayUId &&
              !dvc.statusRelayId // is not belong to other device as command relay
              // && !dvc.doorbellDeviceId
            ) {
              _devices.push(dvc);
            }
          } else if (deviceType == DeviceTypes.SENSOR) {
            if (
              (area.uDevices?.includes(dvc.deviceUId) ||
                area.devices?.includes(dvc.deviceId)) &&
              SensorDeviceTypes.indexOf(dvc.deviceType) >= 0
            ) {
              // if (dvc.deviceType !== DeviceTypes.LIGHT_METER) {
              //   filteredDeviceTypeByLightMeter =
              //     filteredDeviceTypeByLightMeter.filter(
              //       (i) => i.deviceUId !== dvc.deviceUId
              //     );
              // }
              // if (
              //   dvc.deviceType == DeviceTypes.LIGHT_METER &&
              //   !filteredDeviceTypeByLightMeter.some(
              //     (d) => d.deviceUId == dvc.deviceUId
              //   )
              // ) {
              //   continue;
              // }
              _devices.push(dvc);
            }
          }
          // else, none doorlock/camera/airConditioner devices
          else {
            if (
              (area.uDevices?.includes(dvc.deviceUId) ||
                area.devices?.includes(dvc.deviceId)) &&
              dvc.deviceType == deviceType
            ) {
              _devices.push(dvc);
            }
          }
        }
        break;
      }
    }
    _devices = _devices.filter((o) => o.showOnHomeScreen);
    // sort by name
    _devices.sort((a, b) => {
      if (a.deviceName && b.deviceName) {
        return a.deviceName > b.deviceName ? 1 : -1;
      } else {
        return 0;
      }
    });

    return _devices;
  };
  showElevatorModal(elevatorId, elevatorUId) {
    this.setState(
      {
        selectedElevator: elevatorId,
        selectedElevatorUId: elevatorUId,
      },
      () => {
        this.closeRBSheetMobileMode();
        let elevator = this.props.DeviceReducer.list.filter(
          (d) => d.deviceId == elevatorId
        )[0];
        if (elevator.elevatorFloors.length != 0) {
          var elevators = this.getDeviceListByType(
            this.state.selectedAreaDeviceType,
            this.state.selectedAreaUId
          );
          for (var i in elevators) {
            // do not unsubscribe for current elevator
            if (elevators[i].deviceId == elevatorId) continue;

            if (elevators[i].floorSubscriptionTopic) {
              this.props.unSubscribeToTopic(
                elevators[i].floorSubscriptionTopic,
                this.state.accessToken
              );
            }
          }

          setTimeout(() => {
            // show modal
            this.setState({
              showModalForElevator: true,
            });
            // subscribe to panelSubscriptionTopic
            if (elevator.panelSubscriptionTopic) {
              this.props.subscribeToTopic(
                elevator.panelSubscriptionTopic,
                this.state.accessToken
              );
            }
          }, 100);
        }
      }
    );
  }

  navigateToCameraView(camera) {
    if (camera.isV380) {
      SecureStore.getItemAsync(CONSTANTS.SERVER_URL)
        .then((serverUrl) => {
          SecureStore.getItemAsync(CONSTANTS.ACCESS_TOKEN)
            .then((accessToken) => {
              var cameraGetInfoUrl = `${serverUrl}Camera/V380Info/${camera.cameraId}`;
              fetch(cameraGetInfoUrl, {
                method: "get",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${accessToken}`,
                },
              })
                .then((res) => {
                  if (res.status == 200) {
                    return res.json();
                  } else return { status: res.status };
                })
                .then((resj) => {
                  if (resj.result && resj.camera) {
                    let {
                      cameraId,
                      friendlyName,
                      ip,
                      port,
                      userName,
                      password,
                    } = resj.camera;

                    if (cameraId && ip && port && userName && password) {
                      var camHelper = new IPCameraHelper();
                      camHelper.play(
                        friendlyName,
                        ip,
                        port,
                        cameraId,
                        userName,
                        password,
                        true, // hasDoorLock
                        serverUrl,
                        accessToken
                      );
                    }
                  }
                })
                .catch(console.log);
            })
            .catch(console.log);
        })
        .catch(console.log);
    } else if (camera.isRTSP) {
      this.closeRBSheetMobileMode();
      this.setState({ rbSheetTitle: "" });
      this.props.navigation.navigate("CameraView", {
        cameraId: camera.cameraId,
      });
    }
  }

  showCameraView(areaId, areaUId, cameraId) {
    if (this.state.selectedCameraId != undefined) {
      // empty state first, to destroy current video player
      this.setState({ selectedCameraId: undefined }, () => {
        // then set new player
        this.setState({ selectedCameraId: { areaId, areaUId, cameraId } });
      });
    } else {
      // just set new player
      this.setState({ selectedCameraId: { areaId, areaUId, cameraId } });
    }

    this.closeRBSheetMobileMode();
    this.setState({ rbSheetTitle: "" });
  }

  hideCameraView() {
    this.setState({ selectedCameraId: undefined });
  }

  navigateToMultiCamera(cameraIds = []) {
    this.closeRBSheetMobileMode();
    this.setState({ rbSheetTitle: "" });
    this.props.navigation.navigate("CameraMultiView", {
      cameraIds,
      areaId: this.state.selectedAreaUId,
      areaUId: this.state.selectedAreaUId,
      areaName: this.state.selectedAreaName,
    });
  }

  navigateToDeviceLog(deviceId, deviceUId, deviceType = "", phaseNumber = 0) {
    this.closeRBSheetMobileMode();
    this.setState({ rbSheetTitle: "" });
    if (deviceId && deviceUId) {
      this.props.navigation.navigate("DeviceLogs", {
        deviceId,
        deviceUId,
        deviceType,
        phaseNumber,
      });
    }
  }
  navigateToWateringSwitch(deviceId) {
    this.closeRBSheetMobileMode();
    this.setState({ rbSheetTitle: "" });
    if (deviceId) {
      this.props.navigate.navigate("WateringSwitch", { deviceId });
    }
  }
  navigateToAreaPowerMeter(areaId, areaUId) {
    this.closeRBSheetMobileMode();
    this.setState({ rbSheetTitle: "" });
    if (areaId || areaUId)
      this.props.navigation.navigate("AreaPowerMeter", { areaId, areaUId });
  }

  navigateToAreaWaterMeter(areaId, areaUId) {
    this.closeRBSheetMobileMode();
    this.setState({ rbSheetTitle: "" });
    if (areaId || areaUId)
      this.props.navigation.navigate("AreaWaterMeter", { areaId, areaUId });
  }
  getDeviceIcon = (device) => {
    var icon = "\ue028"; // sensor (as default)
    switch (device.deviceType) {
      case DeviceTypes.MOTION_SENSOR:
        //icon = "\ue028"; // running
        if (device.movementDetected) {
          icon = "\ue029"; // with alert
        } else {
          icon = "\ue028"; // without alert
        }
        break;
      case DeviceTypes.THERMO_METER:
        icon = "\uf2c9"; // thermometer-half
        break;
      case DeviceTypes.HUMIDITY_SENSOR:
        icon = faCharCodes.faHumidity;
        break;
      case DeviceTypes.VOLTAGE_SENSOR:
        icon = faCharCodes.faMonitorHeartRate;
        break;
      case DeviceTypes.LIGHT_METER:
        //icon = "\uf6bc"; // candle-half
        icon = "\uf8b8"; // flashlight
        break;
      case DeviceTypes.DOOR_SENSOR:
        if (device.isOpen) {
          icon = "\uf52b"; // door-open
        } else {
          icon = "\uf52a"; // door-closed
        }
        break;
      case DeviceTypes.LEAK_DETECTOR:
        if (device.detected) {
          icon = "\ue029"; // faSensorAlert
        } else {
          icon = "\ue028"; // faSenesor
        }
        break;
      case DeviceTypes.SMOKE_DETECTOR:
        if (device.detected) {
          icon = "\ue02a"; // faSensorFire
        } else {
          icon = "\ue028"; // faSensor
        }
        break;
      case DeviceTypes.SENSOR_BINARY:
        if (device.value) {
          icon = "\ue02b"; // faSensorOn
        } else {
          icon = "\ue028"; // faSensor
        }
        break;
      default:
        console.log("no icon detected for deviceType", device.deviceType);
        break;
    }
    return icon;
  };

  showChangeAreaStateConfirm(stateId, stateUId, stateName, action) {
    this.closeRBSheetMobileMode();
    this.setState({
      areaStateActionToChange: action,
      areaStateIdToChange: stateId,
      areaStateUIdToChange: stateUId,
      areaStateNameToChange: stateName,
      isShowChangeAreaStateConfirm: true,
    });
  }

  hideChangeAreaStateConfirm() {
    this.setState({
      areaStateActionToChange: null,
      areaStateIdToChange: null,
      areaStateUIdToChange: null,
      areaStateNameToChange: null,
      isShowChangeAreaStateConfirm: false,
    });
  }

  changeAreaState = (userState) => {
    this.hideActiveModal();
    if (userState.id == this.state.armStateId) {
      let areaRef = null;
      areaRef = this.AreasRef.filter(
        (a) => a.areaId == this.state.selectedArea.areaId
      )[0];
      if (areaRef) {
        areaRef.ref.loadArmModal();
      }
    }
    var shouldConfirm = false;
    if (
      Array.isArray(userState.devicesStatus) &&
      userState.devicesStatus.some((dvc) => dvc.manager == "DoorLockManager")
    ) {
      shouldConfirm = true;
    } else if (
      Array.isArray(userState.scenariosToRun) &&
      userState.scenariosToRun.length > 0
    ) {
      for (var sn in userState.scenariosToRun) {
        let scnId = userState.scenariosToRun[sn].scenarioId;
        let scnUId = userState.scenariosToRun[sn].scenarioUId;
        var scn = this.props.ScenarioReducer.scenarios.filter(
          (sc) => sc.uId == scnUId || (!scnUId && sc.id == scnId)
        )[0];
        if (
          scn &&
          Array.isArray(scn.actions) &&
          scn.actions.some(
            (sa) =>
              sa.manager == "DoorLockManager" &&
              (sa.action == "Open" || sa.action == "OpenAll")
          )
        ) {
          shouldConfirm = true;
        }
      }
    }
    shouldConfirm = shouldConfirm || userState.shouldConfirm;
    // Active userState
    if (!userState.isActivated) {
      if (shouldConfirm) {
        this.showChangeAreaStateConfirm(
          userState.id,
          userState.uId,
          userState.name,
          "activate"
        );
      } else {
        this.props.activateState(
          userState.id,
          userState.uId,
          this.state.accessToken
        );
      }
    }

    // deActive userState
    else if (userState.isActivated) {
      if (shouldConfirm) {
        this.showChangeAreaStateConfirm(
          userState.id,
          userState.uId,
          userState.name,
          "deActivate"
        );
      } else {
        this.props.deActivateState(
          userState.id,
          userState.uId,
          this.state.accessToken
        );
      }
    }
  };
  changeUserDefinedStatesList = (isAreaArmable, userDefinedStates) => {
    //  isAreaArmable is true and any state in userDefinedState is active, should add arm to userDefinedState lsit
    var result = [...userDefinedStates];
    if (isAreaArmable && userDefinedStates.some((s) => s.isActivated)) {
      result = [
        {
          id: this.state.armStateId,
          name: translate("deviceLog.areaarm"),
          isActivated: false,
          activeIcon: faCharCodes.faShieldCheck,
          deActiveIcon: faCharCodes.faShield,
        },
        ...userDefinedStates,
      ];
    }
    return result;
  };

  setSelectedSmartSpeakerDeviceUId = (
    areaId,
    areaUId,
    deviceId,
    deviceUId,
    playListId,
    playListUId,
    callBack
  ) => {
    this.setState(
      {
        selectedAreaId: areaId,
        selectedAreaUId: areaUId,
        selectedSmartSpeakerDeviceUId: deviceUId,
        selectedSmartSpeakerDeviceId: deviceId,
        selectedPlayListId: playListId,
        selectedPlayListUId: playListUId,
        activeTab: "multiMedia",
      },
      () => {
        typeof callBack == "function" && callBack();

        if (!this.props.DeviceReducer.multiMediasLoaded) {
          this.props.getAllPlaylists(this.state.accessToken);
        }
      }
    );
  };

  renderRBSheetAreaState = (selectedArea) => {
    var userDefinedStates = this.changeUserDefinedStatesList(
      selectedArea.isArmable,
      selectedArea.userDefinedStates
    );
    if (userDefinedStates && userDefinedStates.length > 0) {
      return (
        <View>
          {/* user state list */}
          {userDefinedStates.map((userState) => (
            <RBSheetInnerAreaState
              key={userState.id}
              text={userState.name}
              icon={userState.isActivated ? "\uf205" : "\uf204"}
              stateIcon={
                userState.isActivated
                  ? userState.activeIcon
                  : userState.deActiveIcon
              }
              value={userState.isActivated}
              onIconPress={() => {
                this.changeAreaState(userState);
              }}
              onTextPress={() => {
                this.changeAreaState(userState);
              }}
              onTogglePress={() => {
                this.changeAreaState(userState);
              }}
            />
          ))}
          {/* end user state list */}
        </View>
      );
    }
  };

  renderRBSheetPlayList = (speakerDeviceId, speakerDeviceUId, playListId) => {
    if (!this.props.DeviceReducer.multiMediasLoaded) {
      return (
        <View style={{ height: RB_SHEET_HEIGHT - 80 }}>
          <AppLoading />
        </View>
      );
    }
    return (
      <MediaPlayerList
        isKioskMode={this.state.isKioskMode}
        smartSpeakerDeviceId={speakerDeviceId}
        smartSpeakerDeviceUId={speakerDeviceUId}
        playListId={playListId}
        onAddPlayListPress={() => {
          this.closeRBSheetMobileMode();
          this.props.navigation.navigate("MediaPlayListForm", {
            id: 0,
            uId: "",
            smartSpeakerDeviceId: speakerDeviceId,
            smartSpeakerDeviceUId: speakerDeviceUId,
          });
        }}
        onEditPress={(playListId, playListUId) => {
          this.closeRBSheetMobileMode();
          this.props.navigation.navigate("MediaPlayListForm", {
            id: playListId,
            uId: playListUId,
            smartSpeakerDeviceId: speakerDeviceId,
            smartSpeakerDeviceUId: speakerDeviceUId,
          });
        }}
        onDeletePress={(playListId, playListUId, playListTitle) => {
          this.closeRBSheetMobileMode();
          this.showDeletePlaylistConfirm(
            playListId,
            playListUId,
            playListTitle
          );
        }}
        onRemoveTrackPress={(trackId, playListId) => {
          console.log("trackId, playListId to remove", trackId, playListId);
        }}
        onPlay={(deviceId, deviceUId, playListId, playListUId, trackId) => {
          this.props.playSpeaker(
            this.state.selectedAreaId,
            this.state.selectedAreaUId,
            deviceId,
            deviceUId,
            playListId,
            playListUId,
            trackId,
            this.state.accessToken
          );
          this.closeRBSheetMobileMode();
        }}
      />
    );
  };

  renderRBSheetInnerDevices = (deviceType, areaId, areaUId) => {
    let _devices = this.getDeviceListByType(deviceType, areaUId);
    // let _devices = this.state.deviceList;
    // console.log("_devices to render", deviceType, _devices);
    if (!deviceType && _devices && _devices.length == 0) {
      if (
        this.props.DeviceReducer &&
        this.props.DeviceReducer.list &&
        this.props.DeviceReducer.list.length > 0
      ) {
        var selectedAreaDeviceType = "";
        if (
          this.props.DeviceReducer.list.some(
            (d) => d.deviceType == DeviceTypes.LIGHT
          )
        ) {
          selectedAreaDeviceType = DeviceTypes.LIGHT;
        } else {
          selectedAreaDeviceType = this.props.DeviceReducer.list[0].deviceType;
        }

        selectedAreaDeviceType &&
          this.setState({
            selectedAreaDeviceType,
          });
      }
    }
    const RenderDeviceContainer = ({ children }) => {
      if (this.state.isKioskMode) {
        return (
          <HStack
            space="10"
            flexWrap="wrap"
            style={{ alignItems: "center", justifyContent: "center" }}
          >
            {children}
          </HStack>
        );
      }
      return <View>{children}</View>;
    };
    switch (deviceType) {
      case DeviceTypes.LIGHT:
        return (
          <View>
            {/* batch actions */}
            <RBSheetInnerBatchAction
              onTurnOnAllPress={() =>
                this.props.updateAllLightsValue(
                  areaId,
                  areaUId,
                  true,
                  this.state.accessToken
                )
              }
              onTurnOffAllPress={() =>
                this.props.updateAllLightsValue(
                  areaId,
                  areaUId,
                  false,
                  this.state.accessToken
                )
              }
            />
            <RenderDeviceContainer>
              {/* end batch actions */}
              {/* devices list */}
              {_devices.map((d) => (
                <RBSheetInnerDeviceItem
                  isKioskMode={this.state.isKioskMode}
                  key={d.deviceId}
                  text={d.deviceName}
                  iconColor={Theme.COLORS.DEVICE_TYPES.LIGHT_DARK}
                  hasReport={d.canEdit}
                  value={d.isTurnedOn}
                  isActive={!d.isFailed && !d.isExcluded}
                  hint={
                    d.isFailed
                      ? translate("device.isFailed")
                      : d.isExcluded
                      ? translate("device.isExcluded")
                      : ""
                  }
                  onReportPress={() => {
                    this.navigateToDeviceLog(d.deviceId, d.deviceUId);
                  }}
                  onIconPress={() => {
                    if (d.isTurnedOn) {
                      this.props.updateLightValue(
                        d.deviceId,
                        d.deviceUId,
                        false,
                        this.state.accessToken
                      );
                    } else {
                      this.props.updateLightValue(
                        d.deviceId,
                        d.deviceUId,
                        true,
                        this.state.accessToken
                      );
                    }
                  }}
                />
              ))}
            </RenderDeviceContainer>
          </View>
        );
      case DeviceTypes.WATERING_SWITCH:
        return (
          <View>
            {/* batch actions */}
            <RBSheetInnerBatchAction
              onTurnOnAllPress={() =>
                this.props.updateAllWateringSwitchesValue(
                  areaId,
                  areaUId,
                  true,
                  this.state.accessToken
                )
              }
              onTurnOffAllPress={() =>
                this.props.updateAllWateringSwitchesValue(
                  areaId,
                  areaUId,
                  false,
                  this.state.accessToken
                )
              }
            />
            <RenderDeviceContainer>
              {/* end batch actions */}
              {_devices.map((d) => (
                <RBSheetInnerDeviceItem
                  isKioskMode={this.state.isKioskMode}
                  key={d.deviceId}
                  text={d.deviceName}
                  value={d.isTurnedOn}
                  iconColor={Theme.COLORS.DEVICE_TYPES.WATERING_SWITCH}
                  isActive={!d.isFailed && !d.isExcluded}
                  hint={
                    d.isFailed
                      ? translate("device.isFailed")
                      : d.isExcluded
                      ? translate("device.isExcluded")
                      : ""
                  }
                  hasReport={d.canEdit}
                  onReportPress={() => {
                    this.navigateToDeviceLog(d.deviceId, d.deviceUId);
                  }}
                  onIconPress={() => {
                    if (d.isTurnedOn) {
                      this.props.updateWateringSwitchValue(
                        d.deviceId,
                        d.deviceUId,
                        false,
                        this.state.accessToken
                      );
                    } else {
                      this.props.updateWateringSwitchValue(
                        d.deviceId,
                        d.deviceUId,
                        true,
                        this.state.accessToken
                      );
                    }
                  }}
                />
              ))}
            </RenderDeviceContainer>
          </View>
        );
      case DeviceTypes.POWER_SWITCH:
        return (
          <View>
            {/* batch actions */}
            <RBSheetInnerBatchAction
              onTurnOnAllPress={() =>
                this.props.updateAllPowerSwitchesValue(
                  areaId,
                  areaUId,
                  true,
                  this.state.accessToken
                )
              }
              onTurnOffAllPress={() =>
                this.props.updateAllPowerSwitchesValue(
                  areaId,
                  areaUId,
                  false,
                  this.state.accessToken
                )
              }
            />
            <RenderDeviceContainer>
              {/* end batch actions */}
              {_devices.map((d) => (
                <RBSheetInnerDeviceItem
                  isKioskMode={this.state.isKioskMode}
                  key={d.deviceId}
                  text={d.deviceName}
                  value={d.isTurnedOn}
                  iconColor={Theme.COLORS.DEVICE_TYPES.POWER_SWITCH}
                  isActive={!d.isFailed && !d.isExcluded}
                  hint={
                    d.isFailed
                      ? translate("device.isFailed")
                      : d.isExcluded
                      ? translate("device.isExcluded")
                      : ""
                  }
                  hasReport={d.canEdit}
                  onReportPress={() => {
                    this.navigateToDeviceLog(d.deviceId, d.deviceUId);
                  }}
                  onIconPress={() => {
                    if (d.isTurnedOn) {
                      this.props.updatePowerSwitchValue(
                        d.deviceId,
                        d.deviceUId,
                        false,
                        this.state.accessToken
                      );
                    } else {
                      this.props.updatePowerSwitchValue(
                        d.deviceId,
                        d.deviceUId,
                        true,
                        this.state.accessToken
                      );
                    }
                  }}
                />
              ))}
            </RenderDeviceContainer>
          </View>
        );
      case DeviceTypes.OUTLET:
        return (
          <View>
            {/* batch actions */}
            <RBSheetInnerBatchAction
              onTurnOnAllPress={() =>
                this.props.updateAllOutletsValue(
                  areaId,
                  areaUId,
                  true,
                  this.state.accessToken
                )
              }
              onTurnOffAllPress={() =>
                this.props.updateAllOutletsValue(
                  areaId,
                  areaUId,
                  false,
                  this.state.accessToken
                )
              }
            />
            <RenderDeviceContainer>
              {/* end batch actions */}
              {_devices.map((d) => (
                <RBSheetInnerDeviceItem
                  isKioskMode={this.state.isKioskMode}
                  key={d.deviceId}
                  text={d.deviceName}
                  value={d.isTurnedOn}
                  iconColor={Theme.COLORS.DEVICE_TYPES.OUTLET_LITE}
                  isActive={!d.isFailed && !d.isExcluded}
                  hint={
                    d.isFailed
                      ? translate("device.isFailed")
                      : d.isExcluded
                      ? translate("device.isExcluded")
                      : ""
                  }
                  hasReport={d.canEdit}
                  onReportPress={() => {
                    this.navigateToDeviceLog(d.deviceId, d.deviceUId);
                  }}
                  onIconPress={() => {
                    if (d.isTurnedOn) {
                      this.props.updateOutletValue(
                        d.deviceId,
                        d.deviceUId,
                        false,
                        this.state.accessToken
                      );
                    } else {
                      this.props.updateOutletValue(
                        d.deviceId,
                        d.deviceUId,
                        true,
                        this.state.accessToken
                      );
                    }
                  }}
                />
              ))}
            </RenderDeviceContainer>
          </View>
        );
      case DeviceTypes.DOORLOCK:
        return (
          <RenderDeviceContainer>
            {_devices.map((d) => (
              <RBSheetInnerDeviceItem
                isKioskMode={this.state.isKioskMode}
                key={d.deviceId}
                text={d.deviceName}
                hasReport={d.canEdit}
                icon={"\uf084"}
                customIcon={
                  <DoorLock
                    isLockCapable={d.isLockCapable || false}
                    onUnLockPress={() => {
                      this.showUnlockDoorConfirm(d.deviceId, d.deviceUId);
                    }}
                    onLockPress={() => {
                      this.props.lockDoorLock(
                        d.deviceId,
                        d.deviceUId,
                        this.state.accessToken
                      );
                    }}
                  />
                }
                loadingTimeOut={0}
                isActive={!d.isFailed && !d.isExcluded}
                hint={
                  d.isFailed
                    ? translate("device.isFailed")
                    : d.isExcluded
                    ? translate("device.isExcluded")
                    : ""
                }
                onReportPress={() => {
                  this.navigateToDeviceLog(d.deviceId, d.deviceUId);
                }}
                onIconPress={() => {
                  this.showUnlockDoorConfirm(d.deviceId, d.deviceUId);
                }}
              />
            ))}
          </RenderDeviceContainer>
        );
      case DeviceTypes.ACCESS_CONTROL:
        return (
          <View>
            <RenderDeviceContainer>
              {/* end batch actions */}
              {/* devices list */}
              {_devices.map((d) => (
                <AccessControl
                  isKioskMode={this.state.isKioskMode}
                  doorState={d.doorState}
                  isDeviceConnected={d.isDeviceConnected}
                  isTampered={d.isTampered}
                  isSystemLocked={d.isSystemLocked}
                  cameraUId={d.cameraUId}
                  key={d.deviceId}
                  text={d.deviceName}
                  iconColor={Theme.COLORS.DEVICE_TYPES.ACCESS_CONTROL}
                  isAdmin={d.canEdit}
                  icon={getIconByDeviceType(DeviceTypes.ACCESS_CONTROL)}
                  isActive={!d.isFailed && !d.isExcluded}
                  hint={
                    d.isFailed
                      ? translate("device.isFailed")
                      : d.isExcluded
                      ? translate("device.isExcluded")
                      : ""
                  }
                  onReportPress={() => {
                    this.navigateToDeviceLog(d.deviceId, d.deviceUId);
                  }}
                  onDoorPress={() => {
                    this.showAccessControlOpenDoorConfirm(
                      d.deviceId,
                      d.deviceUId,
                      d.deviceName
                    );
                  }}
                  onDevicePress={() => {}}
                  onCameraPress={() => {
                    this.accessControlRequestNotification(
                      d.deviceId,
                      d.deviceUId
                    );
                  }}
                  onSystemLockPress={() => {
                    this.accessControlToggleSystemLock(d.deviceId, d.deviceUId);
                  }}
                />
              ))}
            </RenderDeviceContainer>
          </View>
        );
      case DeviceTypes.DOORBELL:
        return (
          <RenderDeviceContainer>
            {_devices.map((d) => (
              <RBSheetInnerDeviceItem
                isKioskMode={this.state.isKioskMode}
                key={d.deviceId}
                text={d.deviceName}
                icon={"\uf06e"}
                hasReport={false}
                loadingTimeOut={0}
                isActive={!d.isFailed && !d.isExcluded}
                hint={
                  d.isFailed
                    ? translate("device.isFailed")
                    : d.isExcluded
                    ? translate("device.isExcluded")
                    : ""
                }
                onReportPress={() => {
                  this.navigateToDeviceLog(d.deviceId, d.deviceUId);
                }}
                onIconPress={() => {
                  this.navigateToCameraView(d);
                }}
              />
            ))}
          </RenderDeviceContainer>
        );
      case DeviceTypes.ELEVATOR:
        return (
          <RenderDeviceContainer>
            {_devices.map((d) => {
              var displayName = d.name;
              var displayFloorName = "";
              if (d.isOutOfService) {
                displayFloorName = translate("elevator.isOutOfService");
              } else if (
                Number.isInteger(d.currentFloor) &&
                d.elevatorFloors &&
                d.elevatorFloors.length
              ) {
                var floorLabel = d.elevatorFloors.filter(
                  (f) => f.floorLevel == d.currentFloor
                )[0];
                if (floorLabel && floorLabel.label) {
                  displayFloorName = `${translate("elevator.floor")}: ${
                    floorLabel.label
                  }`;
                }
              }
              return (
                <RBSheetInnerDeviceItem
                  isKioskMode={this.state.isKioskMode}
                  key={d.deviceId}
                  text={displayName}
                  hint={displayFloorName}
                  hasReport={false}
                  isActive={true}
                  icon={d.isOutOfService ? "" : "\ue030"}
                  onTextPress={() => {
                    !d.isOutOfService &&
                      this.showElevatorModal(d.deviceId, d.deviceUId);
                  }}
                  onIconPress={() => {
                    !d.isOutOfService &&
                      this.showElevatorModal(d.deviceId, d.deviceUId);
                  }}
                />
              );
            })}
          </RenderDeviceContainer>
        );
      case DeviceTypes.CAMERA:
        let _rtspDevices = [];
        for (var c in _devices) {
          if (_devices[c].isRTSP) {
            _rtspDevices.push(_devices[c].cameraId);
          }
        }
        return (
          <RenderDeviceContainer>
            {/* show all icon */}
            {_rtspDevices.length > 1 && (
              <RBSheetInnerDeviceItem
                isKioskMode={this.state.isKioskMode}
                text={translate("camera.allCameras")}
                icon={"\uf8ac"}
                isActive={true}
                iconStyle={{ fontFamily: "FontAwesomeProRegular" }}
                hasReport={false}
                loadingTimeOut={0}
                onIconPress={() => {
                  this.navigateToMultiCamera(_rtspDevices);
                }}
              />
            )}
            {_devices.map((d, i) => (
              <RBSheetInnerDeviceItem
                isKioskMode={this.state.isKioskMode}
                key={i}
                text={d.deviceName}
                icon={!d.doorbellDeviceId ? "\uf8ac" : "\uf832"}
                isActive={true}
                hasReport={d.canEdit}
                loadingTimeOut={0}
                onIconPress={() => {
                  if (d.isRTSP) {
                    this.showCameraView(areaId, areaUId, d.cameraId);
                  } else {
                    this.navigateToCameraView(d);
                  }
                }}
                onReportPress={() => {
                  this.navigateToDeviceLog(d.deviceId, d.deviceUId);
                }}
              />
            ))}
          </RenderDeviceContainer>
        );
      case DeviceTypes.AIR_CONDITIONER:
        return (
          <View>
            {/* batch actions */}
            {!_devices.some(
              (d) =>
                d.genericType && d.genericType.toLowerCase() == "thermostat"
            ) && (
              <RBSheetInnerBatchAction
                onTurnOnAllPress={() =>
                  this.props.updateAllAirConditionersValue(
                    areaId,
                    areaUId,
                    true,
                    this.state.accessToken
                  )
                }
                onTurnOffAllPress={() =>
                  this.props.updateAllAirConditionersValue(
                    areaId,
                    areaUId,
                    false,
                    this.state.accessToken
                  )
                }
              />
            )}
            <RenderDeviceContainer>
              {/* end batch actions */}
              {_devices.map((d, i) => {
                if (
                  (d.genericType &&
                    d.genericType.toLowerCase() == "thermostat") ||
                  d.zhvacUnitNumber > 0
                ) {
                  return (
                    <View>
                      <AirConditionerThermostat
                        key={i}
                        isTurnedOn={d.isTurnedOn}
                        currentTemperature={d.currentTemperature}
                        humidity={d.humidity}
                        deviceId={d.deviceId}
                        deviceName={d.deviceName}
                        setPoint={d.setPoint}
                        setPointUnit={d.setPointUnit}
                        thermostatFanMode={
                          d.zhvacUnitNumber == 0
                            ? d.thermostatFanMode
                            : d.zhvacFanSpeed
                        }
                        thermostatFanState={d.thermostatFanState}
                        thermostatMode={
                          d.zhvacUnitNumber == 0
                            ? d.thermostatMode
                            : d.zhvacMdde
                        }
                        thermostatOperatingState={d.thermostatOperatingState}
                        thermostatEconomyEnabled={d.economyEnabled}
                        zhvacUnitNumber={d.zhvacUnitNumber}
                        zhvacMode={d.zhvacMode}
                        zhvacFanSpeed={d.zhvacFanSpeed}
                        onToggle={(val) => {
                          this.props.updateAirConditionerValue(
                            d.deviceId,
                            d.deviceUId,
                            val,
                            this.state.accessToken
                          );
                        }}
                        onSetPointChange={(value) =>
                          this.props.updateAirConditionerSetPoint(
                            d.deviceId,
                            d.deviceUId,
                            value,
                            this.state.accessToken
                          )
                        }
                        onThermostatFanModeChange={(mode) => {
                          this.props.updateAirConditionerFanMode(
                            d.deviceId,
                            d.deviceUId,
                            mode,
                            this.state.accessToken
                          );
                        }}
                        onThermostatModeChange={(mode, economy) => {
                          this.props.updateAirConditionerMode(
                            d.deviceId,
                            d.deviceUId,
                            mode,
                            economy || false,
                            this.state.accessToken
                          );
                        }}
                      />
                    </View>
                  );
                }
                {
                  /* else, render simple switch binary component */
                }
                return (
                  <RBSheetInnerDeviceItem
                    isKioskMode={this.state.isKioskMode}
                    key={d.deviceId}
                    text={d.deviceName}
                    value={d.isTurnedOn}
                    hasReport={d.canEdit}
                    isActive={!d.isFailed && !d.isExcluded}
                    hint={
                      d.isFailed
                        ? translate("device.isFailed")
                        : d.isExcluded
                        ? translate("device.isExcluded")
                        : ""
                    }
                    ignoreEventLoading={d.commandRelayId > 0 ? 1 : 0}
                    iconColor={Theme.COLORS.DEVICE_TYPES.AIR_CONDITIONER}
                    onReportPress={() => {
                      this.navigateToDeviceLog(d.deviceId, d.deviceUId);
                    }}
                    onIconPress={() => {
                      if (d.isTurnedOn) {
                        this.props.updateAirConditionerValue(
                          d.deviceId,
                          d.deviceUId,
                          false,
                          this.state.accessToken
                        );
                      } else {
                        this.props.updateAirConditionerValue(
                          d.deviceId,
                          d.deviceUId,
                          true,
                          this.state.accessToken
                        );
                      }
                    }}
                  />
                );
              })}
            </RenderDeviceContainer>
          </View>
        );
      case DeviceTypes.POWER_METER:
      case DeviceTypes.WATER_METER:
        return (
          <RenderDeviceContainer>
            {_devices.map((d, i) => {
              return (
                <RBSheetInnerDeviceItem
                  isKioskMode={this.state.isKioskMode}
                  key={i}
                  text={d.deviceName}
                  hasReport={false}
                  loadingTimeOut={0}
                  isActive={true}
                  icon={
                    d.deviceType == DeviceTypes.POWER_METER
                      ? "\uf0e7"
                      : d.deviceType == DeviceTypes.WATER_METER
                      ? "\uf75c"
                      : "\uf627"
                  }
                  onTextPress={() => {
                    if (d.deviceType == DeviceTypes.POWER_METER) {
                      this.navigateToAreaPowerMeter(areaId, areaUId);
                    } else if (d.deviceType == DeviceTypes.WATER_METER) {
                      this.navigateToAreaWaterMeter(areaId, areaUId);
                    }
                  }}
                  onIconPress={() => {
                    if (d.deviceType == DeviceTypes.POWER_METER) {
                      this.navigateToAreaPowerMeter(areaId, areaUId);
                    } else if (d.deviceType == DeviceTypes.WATER_METER) {
                      this.navigateToAreaWaterMeter(areaId, areaUId);
                    }
                  }}
                />
              );
            })}
          </RenderDeviceContainer>
        );
      case DeviceTypes.CURTAIN:
        return (
          <RenderDeviceContainer>
            {_devices.map((d, i) => {
              return (
                <Curtain
                  deviceId={d.deviceId}
                  deviceName={d.deviceName}
                  key={d.deviceId}
                  value={d.value}
                  userValue={d.userValue}
                  onReportPress={() => {
                    this.navigateToDeviceLog(d.deviceId, d.deviceUId);
                  }}
                  onValueChange={(value) =>
                    this.props.updateCurtainValue(
                      d.deviceId,
                      d.deviceUId,
                      value,
                      this.state.accessToken
                    )
                  }
                />
              );
            })}
          </RenderDeviceContainer>
        );
        break;
      case DeviceTypes.SENSOR:
        return (
          <RenderDeviceContainer>
            {_devices.map((d, i) => (
              <RBSheetInnerDeviceItem
                isKioskMode={this.state.isKioskMode}
                key={i}
                text={
                  d.deviceType == DeviceTypes.VOLTAGE_SENSOR
                    ? `${d.deviceName} (${d.value} ${d.unit || "V"})`
                    : d.deviceName
                }
                deviceId={d.deviceId}
                deviceType={d.deviceType}
                batteryLevel={d.batteryLevel}
                loadingTimeOut={0}
                hasReport={d.canEdit}
                isActive={!d.isFailed && !d.isExcluded}
                doorState={d.doorState}
                iconColor={
                  d.doorState && (d.doorState == "E" || d.doorState == "H")
                    ? Theme.COLORS.ERROR
                    : ""
                }
                iconStyle={{ fontSize: this.state.isKioskMode ? 40 : 26 }}
                hint={
                  d.isFailed
                    ? translate("device.isFailed")
                    : d.isExcluded
                    ? translate("device.isExcluded")
                    : ""
                }
                value={d.movementDetected || false}
                icon={this.getDeviceIcon(d)}
                onMovementDetection={() => {
                  setTimeout(() => {
                    this.props.restoreMotionDetection(
                      d.deviceId || d.deviceUId
                    );
                  }, 1000);
                }}
                onReportPress={() => {
                  d.canEdit &&
                    this.navigateToDeviceLog(
                      d.deviceId,
                      d.deviceUId,
                      d.deviceType,
                      d.phaseNumber || 0
                    );
                }}
                onIconPress={() => {
                  d.canEdit &&
                    this.navigateToDeviceLog(
                      d.deviceId,
                      d.deviceUId,
                      d.deviceType,
                      d.phaseNumber || 0
                    );
                }}
              />
            ))}
          </RenderDeviceContainer>
        );

      case DeviceTypes.SIREN:
        return (
          <View>
            {/* batch actions */}
            <RBSheetInnerBatchAction
              onTurnOnAllPress={() => {
                this.showTurnOnSirenConfirm(
                  areaId,
                  areaUId,
                  null,
                  null,
                  "",
                  true
                );
              }}
              onTurnOffAllPress={() =>
                this.props.updateAllSirensValue(
                  areaId,
                  areaUId,
                  false,
                  this.state.accessToken
                )
              }
            />
            {/* end batch actions */}
            {/* devices list */}
            <RenderDeviceContainer>
              {_devices.map((d) => (
                <RBSheetInnerDeviceItem
                  isKioskMode={this.state.isKioskMode}
                  key={d.deviceId}
                  text={d.deviceName}
                  iconColor={Theme.COLORS.DEVICE_TYPES.SIREN}
                  hasReport={d.canEdit}
                  value={d.isTurnedOn}
                  isActive={!d.isFailed && !d.isExcluded}
                  hint={
                    d.isFailed
                      ? translate("device.isFailed")
                      : d.isExcluded
                      ? translate("device.isExcluded")
                      : ""
                  }
                  onReportPress={() => {
                    this.navigateToDeviceLog(d.deviceId, d.deviceUId);
                  }}
                  onIconPress={() => {
                    if (d.isTurnedOn) {
                      this.props.updateSirenValue(
                        d.deviceId,
                        d.deviceUId,
                        false,
                        this.state.accessToken
                      );
                    } else {
                      this.showTurnOnSirenConfirm(
                        0,
                        null,
                        d.deviceId,
                        d.deviceUId,
                        d.deviceName,
                        true
                      );
                    }
                  }}
                />
              ))}
            </RenderDeviceContainer>
            {/* end devices list */}
          </View>
        );
      case DeviceTypes.SMART_SPEAKER:
        return (
          <RenderDeviceContainer>
            {/* media renderer */}

            {/* end media renderer */}
            {/* devices list */}
            {_devices.map((d) => (
              <RBSheetInnerDeviceItem
                isKioskMode={this.state.isKioskMode}
                key={d.deviceId}
                text={d.deviceName}
                icon={faCharCodes.faPlayCircle}
                iconColor={Theme.COLORS.DEVICE_TYPES.SMART_SPEAKER}
                hasReport={d.canEdit}
                isActive={true}
                onReportPress={() => {
                  this.navigateToDeviceLog(d.deviceId, d.deviceUId);
                }}
                onIconPress={() => {
                  this.setSelectedSmartSpeakerDeviceUId(
                    this.state.selectedAreaId,
                    this.state.selectedAreaUId,
                    d.deviceId,
                    d.deviceUId,
                    null,
                    null,
                    null
                  );
                }}
              />
            ))}
            {/* end devices list */}
          </RenderDeviceContainer>
        );

      default:
        if (deviceType) {
          console.warn(
            "renderRBSheetInnerDevices not implemented for deviceType",
            deviceType
          );
        }
        break;
    }
  };
  renderRBSheetInnerAreas = (areaType, areaId) => {
    const areaListBathroom = useAreaListByAreaType(
      this.props.AreaReducer.areas,
      areaId,
      areaType
    );
    switch (areaType) {
      case AreaTypes.BATHROOM:
        return (
          <View>
            {/* devices list */}
            {areaListBathroom.map((d) => {
              return (
                <RBSheetInnerDeviceItem
                  isKioskMode={this.state.isKioskMode}
                  key={d.areaId}
                  text={d.areaName}
                  hasReport={false}
                  loadingTimeOut={0}
                  isActive={true}
                  statusColor={
                    d.extra.isOutOfService
                      ? Theme.COLORS.MUTED
                      : d.isOccupied
                      ? Theme.COLORS.ERROR
                      : Theme.COLORS.SUCCESS
                  }
                  icon={
                    d.extra.gender == "men"
                      ? faCharCodes.faMale
                      : d.extra.gender == "women"
                      ? faCharCodes.faFemale
                      : faCharCodes.faRestroom
                  }
                />
              );
            })}
            {/* end devices list */}
          </View>
        );
      default:
        if (areaType) {
          console.warn(
            "renderRBSheetInnerDevices not implemented for deviceType",
            areaType
          );
        }
        break;
    }
  };
  renderRBSheetInnerOrdersList = () => {
    const handlerNavigate = (screen) => {
      this.hideActiveModal();
      this.props.navigation.navigate(screen);
    };
    return (
      <View style={{ marginTop: 5 }}>
        {/* Public Services */}
        <RBSheetInnerSettingItem
          text={translate("navigation.PublicServices")}
          icon={"\uf562"}
          onPress={() => {
            handlerNavigate("PublicServices");
          }}
        />

        {/*Restaurant and CoffeeShop*/}
        <RBSheetInnerSettingItem
          text={translate("navigation.RestaurantAndCoffeeShop")}
          icon={"\uf86b"}
          onPress={() => {
            handlerNavigate("RestaurantAndCoffeeShop");
          }}
        />

        {/* CarWash */}
        <RBSheetInnerSettingItem
          text={translate("navigation.CarWash")}
          icon={"\uf5e6"}
          onPress={() => {
            handlerNavigate("CarWash");
          }}
        />
        {/* Parking */}
        <RBSheetInnerSettingItem
          text={translate("navigation.Parking")}
          icon={"\uf615"}
          onPress={() => {
            handlerNavigate("Parking");
          }}
        />
        {/*  access Ribbon User */}
        <RBSheetInnerSettingItem
          text={translate("navigation.EditRibbonUserAccessLevel")}
          icon={"\uf29a"}
          onPress={() => {
            handlerNavigate("EditRibbonUserAccessLevel");
          }}
        />
        {/* IncreaseCredit */}
        <RBSheetInnerSettingItem
          text={translate("navigation.IncreaseCredit")}
          icon={"\uf53d"}
          onPress={() => {
            handlerNavigate("IncreaseCredit");
          }}
        />
      </View>
    );
  };

  renderModalInnerBuildings = () => {
    return (
      <View style={{ marginTop: 5 }}>
        {/* === add Building & join building ===  */}
        {this.renderCreateBuildingHandler()}
        {this.props.AppReducer.buildings.length === 0 ? (
          <MessageBox>{translate("app.noBuilding")}</MessageBox>
        ) : (
          this.props.AppReducer.buildings
            .sort((a, b) =>
              a.buildingId == this.props.AppReducer?.currentBuilding?.buildingId
                ? -1
                : 1
            )
            .map((building, i) => (
              <UserProfile
                homeUserProfile={true}
                style={{ marginVertical: 5 }}
                key={i}
                buildingCode={building.code}
                buildingId={building.buildingId}
                buildingName={building.buildingName}
                userFullName={building.userDisplayName}
                selected={
                  building.buildingId ==
                  this.props.AppReducer?.currentBuilding?.buildingId
                }
                serverId={building.serverId}
                onSelect={async () => {
                  await this.handleOnBuildingChanged(building);
                }}
                onShowQRCodeModal={() => {
                  this.setState({
                    showQRCodeJoinBuilding: true,
                    selectedJoinBuildingInfo: building,
                  });
                }}
              />
            ))
        )}
      </View>
    );
  };

  handleOnAreaItemPress = (areaId, areaUId, areaName, deviceType) => {
    var _devices = this.getDeviceListByType(deviceType, areaUId);
    // === show open RBSheet in mobile Mode
    const returnShowDeviceList = () => {
      !this.state.isKioskMode && this.RBSheet.open();
    };
    // === handle elevators ===
    if (deviceType == DeviceTypes.ELEVATOR) {
      var elevators = _devices; //this.getDeviceListByType(deviceType, areaId);
      if (elevators.length == 1) {
        this.showElevatorModal(elevators[0].deviceId, elevators[0].deviceUId);
        return;
      } else {
        this.setState(
          {
            showModalForElevator: false,
            deviceList: _devices,
            rbSheetTitle: deviceType,
            selectedAreaId: areaId,
            selectedAreaUId: areaUId,
            selectedAreaName: areaName,
            selectedAreaDeviceType: deviceType,
            activeTab: "home",
          },
          () => returnShowDeviceList()
        );

        // subscribe to floorSubscriptionTopic only for all elevators.
        // panelSubscriptionTopic will call when modal is open.
        for (var i in elevators) {
          if (elevators[i].floorSubscriptionTopic) {
            this.props.subscribeToTopic(
              elevators[i].floorSubscriptionTopic,
              this.state.accessToken
            );
          }
        }
      }
    }
    // handle doorBells
    else if (deviceType == DeviceTypes.DOORBELL) {
      var doorBells = _devices;
      if (doorBells.length == 1) {
        this.navigateToCameraView(doorBells[0]);
      } else {
        this.setState(
          {
            deviceList: _devices,
            rbSheetTitle: deviceType,
            selectedAreaId: areaId,
            selectedAreaUId: areaUId,
            selectedAreaName: areaName,
            selectedAreaDeviceType: deviceType,
            activeTab: "home",
          },
          () => returnShowDeviceList()
        );
      }
    }

    // handle smart speakers
    else if (deviceType == DeviceTypes.SMART_SPEAKER) {
      var speakers = _devices;
      if (speakers.length == 1) {
        this.setSelectedSmartSpeakerDeviceUId(
          areaId,
          areaUId,
          speakers[0].deviceId,
          speakers[0].deviceUId,
          null,
          null,
          () => returnShowDeviceList()
        );
      } else {
        this.setState(
          {
            deviceList: _devices,
            rbSheetTitle: deviceType,
            selectedAreaId: areaId,
            selectedAreaUId: areaUId,
            selectedAreaName: areaName,
            selectedAreaDeviceType: deviceType,
            activeTab: "home",
          },
          () => returnShowDeviceList()
        );
      }
    }

    // handle single camera
    else if (
      deviceType == DeviceTypes.CAMERA &&
      _devices.length == 1 &&
      _devices[0].isRTSP
    ) {
      this.showCameraView(areaId, areaUId, _devices[0].cameraId);
    }
    // handle other types
    else {
      this.setState(
        {
          deviceList: _devices,
          rbSheetTitle: deviceType,
          selectedAreaId: areaId,
          selectedAreaUId: areaUId,
          selectedAreaName: areaName,
          selectedAreaDeviceType: deviceType,
          activeTab: "home",
        },
        () => returnShowDeviceList()
      );
    }
  };
  handleOnAreaTypeItem = (areaId, areaName, areaType) => {
    this.setState(
      {
        selectedAreaUId: areaId,
        selectedAreaName: areaName,
        selectedAreaTypeItem: areaType,
        rbSheetTitle: areaType,
      },
      () => {
        this.setState({ activeTab: "areaType" }, () => {
          !this.state.isKioskMode && this.RBSheet.open();
        });
      }
    );
  };
  showUnlockDoorConfirm(doorLockDeviceId, doorLockDeviceUId) {
    // close rbSheet on web, to prevent door confirm and rbsheet backdrops conflict.
    this.closeRBSheetMobileMode();
    setTimeout(() => {
      this.setState({
        isShowingUnlockDoorAlert: true,
        doorToUnlockDeviceId: doorLockDeviceId,
        doorToUnlockDeviceUId: doorLockDeviceUId,
      });
    }, 500);
  }

  // === Access Control ===
  showAccessControlOpenDoorConfirm(
    accessControlDeviceId,
    accessControlDeviceUId,
    accessControlDeviceName
  ) {
    // close rbSheet on web, to prevent door confirm and rbsheet backdrops conflict.
    this.closeRBSheetMobileMode();
    setTimeout(() => {
      this.setState({
        isShowingAccessControlOpenDoorConfirm: true,
        accessControlToOpenDoorDeviceId: accessControlDeviceId,
        accessControlToOpenDoorDeviceUId: accessControlDeviceUId,
        accessControlToOpenDoorDeviceName: accessControlDeviceName,
      });
    }, 500);
  }
  hideAccessControlOpenDoorConfirm() {
    this.setState({
      isShowingAccessControlOpenDoorConfirm: false,
      accessControlToOpenDoorDeviceId: undefined,
      accessControlToOpenDoorDeviceUId: undefined,
      accessControlToOpenDoorDeviceName: undefined,
    });
  }

  hideAccessControlNotification(processId) {
    // if (this.props.DeviceReducer.accessControlCameraProcessId == processId) {
    this.props.DeviceReducer.isShowingAccessControlNotification = false;
    this.setState({
      isShowingAccessControlNotification: false,
    });
    this.props.accessControlClosetCamera(processId, this.state.accessToken);
    // }
  }
  accessControlOpenDoor = (deviceId, deviceUId) => {
    this.props.accessControlOpenDoor(
      deviceId,
      deviceUId,
      this.state.accessToken
    );
    this.hideAccessControlOpenDoorConfirm();
  };

  showAccessControlOpenAllAreaDoorsConfirm(areaId, areaUId) {
    // close rbSheet on web, to prevent door confirm and rbsheet backdrops conflict.
    this.closeRBSheetMobileMode();
    setTimeout(() => {
      this.setState({
        isShowingAccessControlOpenAllAreaDoorsConfirm: true,
        accessControlToOpenAllDoorsAreaId: areaId,
        accessControlToOpenAllDoorsAreaUId: areaUId,
      });
    }, 500);
  }
  hideAccessControlOpenAllAreaDoorsConfirm() {
    this.setState({
      isShowingAccessControlOpenAllAreaDoorsConfirm: false,
      accessControlToOpenAllDoorsAreaId: undefined,
      accessControlToOpenAllDoorsAreaUId: undefined,
    });
  }
  accessControlOpenAllAreaDoors = (areaId, areaUId) => {
    this.props.accessControlOpenAllAreaDoors(
      areaId,
      areaUId,
      this.state.accessToken
    );
    this.hideAccessControlOpenDoorConfirm();
  };

  accessControlRequestNotification = (deviceId, deviceUId) => {
    this.props.accessControlRequestNotification(
      deviceId,
      deviceUId,
      this.state.accessToken
    );
  };
  accessControlToggleSystemLock = (deviceId, deviceUId) => {
    this.props.accessControlToggleSystemLock(
      deviceId,
      deviceUId,
      this.state.accessToken
    );
  };

  hideAccessControlAcknowledgement() {
    this.setState({
      isShowingAccessControlAcknowledgement: false,
      accessControlAcknowledgementToConfirmEventId: undefined,
      accessControlAcknowledgementToConfirmDeviceName: undefined,
      accessControlAcknowledgementToConfirmEventCode: undefined,
      accessControlAcknowledgementToConfirmPersianDate: undefined,
    });
  }
  showAccessControlAcknowledgement(
    eventId,
    deviceName,
    eventCode,
    persianDate
  ) {
    // close rbSheet on web, to prevent door confirm and rbsheet backdrops conflict.
    this.closeRBSheetMobileMode();
    this.setState({
      isShowingAccessControlAcknowledgement: true,
      accessControlAcknowledgementToConfirmEventId: eventId,
      accessControlAcknowledgementToConfirmDeviceName: deviceName,
      accessControlAcknowledgementToConfirmEventCode: eventCode,
      accessControlAcknowledgementToConfirmPersianDate: persianDate,
    });
  }
  accessControlConfirmAcknowledgement(eventId) {
    this.props.accessControlConfirmAcknowledgement(
      eventId,
      this.state.accessToken
    );
  }

  hideUserSessionsWarning(
  ) {
    // close rbSheet on web, to prevent door confirm and rbsheet backdrops conflict.
    this.closeRBSheetMobileMode();
    this.setState({
      isShowingUserSessionsWarning: false,
    });
  }

  showTurnOnSirenConfirm(
    areaId = 0,
    areaUId = null,
    sirenDeviceId = 0,
    sirenDeviceUId = null,
    sirenDeviceName = "",
    value
  ) {
    this.closeRBSheetMobileMode();
    setTimeout(() => {
      this.setState({
        sirenToTurnOn: {
          showConfirm: true,
          areaId,
          areaUId,
          sirenDeviceId,
          sirenDeviceUId,
          sirenDeviceName,
          value,
        },
      });
    }, 500);
  }

  hideTurnOnSirenConfirm() {
    this.setState({
      sirenToTurnOn: {
        showConfirm: false,
        areaId: 0,
        areaUId: null,
        sirenDeviceId: 0,
        sirenDeviceUId: null,
        sirenDeviceName: "",
      },
    });
  }

  hideUnlockDoorConfirm() {
    this.setState({
      isShowingUnlockDoorAlert: false,
      doorToUnlockDeviceId: undefined,
      doorToUnlockDeviceUId: undefined,
    });
  }

  showDeletePlaylistConfirm(id, uId, title) {
    this.setState({
      playListIdToDelete: id,
      playListUIdToDelete: uId,
      playListTitleToDelete: title,
    });
  }

  hideDeletePlaylistConfirm() {
    this.setState({
      playListIdToDelete: 0,
      playListUIdToDelete: null,
      playListTitleToDelete: "",
    });
  }

  navigateToLogout = () => {
    this.props.resetLogoutToggle();
    this.props.logout();
    this.props.navigation.replace("Login");
    this.closeRBSheetMobileMode();
  };

  refreshData = async (buildingId = null, callBack = null) => {
    const { buildings, servers } = await fetchUserBuildings(
      this.props.AppReducer.currentServer?.accessToken,
      this.props.AppReducer.serverUrl
    );
    this.props.setBuildings(buildings);
    this.props.setServers(servers);
    const findBuilding = buildings.find(
      (building) => building.buildingId === buildingId
    );
    var _buildingId = "";
    if (findBuilding) {
      var _buildingId = findBuilding.buildingId;
    } else if (buildings.length > 0) {
      _buildingId = buildings[0].buildingId;
      this.props.updateCurrentBuilding(buildings[0]);
    } else {
      this.props.updateCurrentBuilding(null);
    }
    this.setState(
      {
        isRefreshing: true,
        waitingForAreaToLoad: true,
        deviceList: [],
        selectedAreaId: 0,
        selectedAreaUId: "",
        selectedAreaDeviceType: "",
      },
      () => {
        this.props.clearCache();
        this.props.forceInit(
          this.props.AppReducer.currentServer?.accessToken,
          _buildingId
        );
        setTimeout(() => {
          this.setState({ isRefreshing: false, waitingForAreaToLoad: false });
        }, 7000);
      }
    );
    if (callBack) {
      typeof callBack == "function" && callBack();
    }
  };

  closeElevatorModal = () => {
    let elevator = this.props.DeviceReducer.list.find(
      (d) => d.deviceId == this.state.selectedElevator
    );
    // unsubscribe to floorSubscriptionTopic
    if (
      elevator &&
      elevator.floorSubscriptionTopic &&
      !this.state.isKioskMode
    ) {
      this.props.unSubscribeToTopic(
        elevator.floorSubscriptionTopic,
        this.state.accessToken
      );
    }

    // unsubscribe to panelSubscriptionTopic
    if (elevator && elevator.panelSubscriptionTopic) {
      this.props.unSubscribeToTopic(
        elevator.panelSubscriptionTopic,
        this.state.accessToken
      );
    }
    // === isKioskMode ===
    if (this.state.isKioskMode) {
      let elevators = this.getDeviceListByType(
        DeviceTypes.ELEVATOR,
        this.state.selectAreaItem
      ).filter((device) => device.deviceId !== this.state.selectedElevator);
      for (var i in elevators) {
        if (elevators[i].floorSubscriptionTopic) {
          this.props.subscribeToTopic(
            elevators[i].floorSubscriptionTopic,
            this.state.accessToken
          );
        }
      }
    }

    this.setState({
      showModalForElevator: false,
      selectedElevator: null,
      selectedElevatorUId: null,
      userFloor: null,
    });
  };
  // === Switch Building Handler ===
  onBuildingProfile = () => {
    this.showActiveModal("buildingProfile");
  };
  renderCreateBuildingHandler = () => {
    return (
      <HStack space={2} p="1.5" style={{ direction: getDir() }}>
        <ArButton
          style={{ flex: 1 }}
          onPress={() => {
            this.setState({
              showJoinModal: true,
            });
          }}
          variant="outline"
          icon={faCharCodes.faSignIn}
          iconColor={Theme.COLORS.PRIMARY}
        >
          {translate("building.joinBuilding")}
        </ArButton>
        <ArButton
          color="primary"
          icon={faCharCodes.faBuilding}
          onPress={() => {
            this.hideActiveModal();
            this.props.navigation.navigate("AddBuilding", {
              changeBuilding: async (buildingId) => {
                const handleCallBackChangeBuilding = async () => {
                  const findBuilding = this.props.AppReducer.buildings.find(
                    (building) => {
                      building.buildingId == buildingId;
                    }
                  );
                  if (findBuilding) {
                    await this.handleOnBuildingChanged(findBuilding);
                  }
                };
                this.refreshData(
                  this.props.AppReducer?.currentBuilding?.buildingId,
                  handleCallBackChangeBuilding()
                );
              },
            });
          }}
          style={{ flex: 1 }}
        >
          {translate("building.addBuilding")}
        </ArButton>
      </HStack>
    );
  };
  checkBadgeNoAreaUsers = () => {
    return this.props.UserReducer?.users?.some(
      (user) => user?.areas?.length === 0
    );
  };
  checkBadgeUpdateDeviceController = () => {
    return this.props.DeviceReducer.list.some(
      (device) => updateDeviceAvailable(device)?.updateAvailable
    );
  };
  onUnlockDoorLock = (deviceId, deviceUId) => {
    this.props.unlockDoorLock(deviceId, deviceUId, this.state.accessToken);
    this.hideUnlockDoorConfirm();
  };
  onUpdateSirenValue = (
    areaId = 0,
    areaUId,
    sirenDeviceId,
    sirenDeviceUId,
    value = false
  ) => {
    const accessToken = this.state.accessToken;
    if (sirenDeviceId || sirenDeviceUId) {
      this.props.updateSirenValue(
        sirenDeviceId,
        sirenDeviceUId,
        value,
        accessToken
      );
    } else if (areaId || areaUId) {
      this.props.updateAllSirensValue(areaId, areaUId, value, accessToken);
    }
  };
  renderAnnouncement = () => {
    return (
      <Collapse isOpen={this.state.appWidgetAnnouncementMessage}>
        {this.state.appWidgetAnnouncementMessage !== null && (
          <AppWidgetAnnouncement
            message={this.state.appWidgetAnnouncementMessage}
            closeHandler={() =>
              this.setState({ appWidgetAnnouncementMessage: null }, () => {
                this.props.clearAnnouncement();
              })
            }
          />
        )}
      </Collapse>
    );
  };
  renderRBSheetInner = () => {
    return (
      <RBSheetInner
        AreaReducer={this.props.AreaReducer}
        DeviceReducer={this.props.DeviceReducer}
        selectedAreaDeviceType={this.state.selectedAreaDeviceType}
        selectedAreaId={this.state.selectedAreaUId}
        selectedAreaName={this.state.selectedAreaName}
      >
        {this.state.activeTab === "home" &&
          this.renderRBSheetInnerDevices(
            this.state.selectedAreaDeviceType,
            this.state.selectedAreaId,
            this.state.selectedAreaUId
          )}
        {this.state.activeTab === "multiMedia" &&
          this.renderRBSheetPlayList(
            this.state.selectedSmartSpeakerDeviceId,
            this.state.selectedSmartSpeakerDeviceUId,
            this.state.selectedPlayListId
          )}
        {this.state.activeTab === "areaType" &&
          this.renderRBSheetInnerAreas(
            this.state.selectedAreaTypeItem,
            this.state.selectedAreaUId
          )}
      </RBSheetInner>
    );
  };
  onUnSubscribeToTopicHandler = () => {
    if (
      this.state.selectedAreaDeviceType == DeviceTypes.ELEVATOR &&
      !this.state.selectedElevator
    ) {
      var elevators = this.getDeviceListByType(
        this.state.selectedAreaDeviceType,
        this.state.selectedAreaUId
      );
      for (var i in elevators) {
        if (elevators[i].floorSubscriptionTopic) {
          this.props.unSubscribeToTopic(
            elevators[i].floorSubscriptionTopic,
            this.state.accessToken
          );
        }
      }
    }

    this.setState({
      selectedAreaDeviceType: "",
      selectedAreaUId: "",
      selectedAreaId: "",
      selectedAreaName: "",
      activeTab: "home",
    });
  };
  closeRBSheetMobileMode = () => {
    !this.state.isKioskMode && this.RBSheet.close();
  };
  // === active Modal ===
  showActiveModal = (title, callBack = undefined) => {
    this.setState(
      {
        activeModal: title,
        activeModalTitle: title,
      },
      callBack
    );
  };
  hideActiveModal = (callBack = undefined) => {
    this.setState(
      {
        activeModal: null,
        activeModalTitle: "",
      },
      callBack
    );
  };
  renderActiveModal = () => {
    switch (this.state.activeModal) {
      case "buildingProfile":
        return this.renderModalInnerBuildings();
      case "ordersList":
        return this.renderRBSheetInnerOrdersList();
      case "areaState":
        return this.renderRBSheetAreaState(this.state.selectedArea);
      case "multiMedia":
        return this.renderRBSheetPlayList(
          this.state.selectedSmartSpeakerDeviceId,
          this.state.selectedSmartSpeakerDeviceUId,
          this.state.selectedPlayListId
        );
      default:
        break;
    }
  };
  renderArea = (ma, _AreasToRender, index) => {
    return (
      <Area
        area={ma}
        isKioskMode={this.state.isKioskMode}
        key={ma.areaId || ma.areaUId}
        ref={(ref) => {
          if (!this.AreasRef.some((a) => a.areaId == ma.areaId)) {
            this.AreasRef.push({
              areaId: ma.areaId,
              ref: ref,
            });
          }
        }}
        expanded={_AreasToRender.length <= 3 || index == 0}
        selectedAreaDeviceType={this.state.selectedAreaDeviceType}
        areaId={ma.areaId || ma.areaUId}
        areaUId={ma.areaUId}
        showAreaState={ma.hasPublicAreaState && !ma.isArmed}
        selectedCameraId={
          this.state.selectedCameraId &&
          (this.state.selectedCameraId.areaId == ma.areaId ||
            this.state.selectedCameraId.areaUId == ma.areaUId)
            ? this.state.selectedCameraId.cameraId
            : undefined
        }
        onSelectedCameraClose={() => this.hideCameraView()}
        onSelectedSmartSpeakerClose={() => {}}
        onMediaPlayerPlayListPress={(
          areaId,
          areaUId,
          deviceId,
          deviceUId,
          playListId,
          playListUId
        ) => {
          this.setSelectedSmartSpeakerDeviceUId(
            areaId,
            areaUId,
            deviceId,
            deviceUId,
            playListId,
            playListUId,
            !this.state.isKioskMode && this.RBSheet.open()
          );
        }}
        OnPressAreaStateIcon={(userState) => {
          this.changeAreaState(userState);
        }}
        onAreaItemPress={(areaId, areaUId, deviceType) =>
          this.handleOnAreaItemPress(areaId, areaUId, ma.areaName, deviceType)
        }
        onAreaTypeItem={(areaId, deviceType) => {
          this.handleOnAreaTypeItem(areaId, ma.areaName, deviceType);
        }}
        onTurnOnAllSirens={() => {
          this.showTurnOnSirenConfirm(ma.areaId, ma.areaUId, 0, null, "", true);
        }}
        onShowAreaStateRBSheet={() => {
          this.setState({
            selectedArea: ma,
          });
          this.showActiveModal("areaState");
        }}
        onUnSubscribeToTopic={this.onUnSubscribeToTopicHandler}
        onAccessControlUnlockAllAreaDoors={() => {
          this.showAccessControlOpenAllAreaDoorsConfirm(ma.areaId, ma.areaUId);
        }}
      >
        {this.renderRBSheetInner()}
      </Area>
    );
  };

  render() {
    let Tabs = [
      {
        tabItem: [
          // === setting ===
          {
            label: translate("navigation.Setting"),
            icon: faCharCodes.faCog,
            callback: () =>
              this.props.navigation.navigate("Setting", {
                hasNewUpdate: this.state.hasNewUpdate || false,
                onBuildingChange: (building) =>
                  this.handleOnBuildingChanged(building),
              }),
          },
        ],
      },
      {
        tabItem: [
          // === Areas ===
          {
            label: translate("navigation.AreasList"),
            icon: faCharCodes.faClone,
            callback: () => this.props.navigation.navigate("Areas"),
          },
          // === Devices ===
          {
            label: translate("navigation.DeviceList"),
            icon: faCharCodes.faLightbulb,
            // badge: this.checkBadgeUpdateDeviceController(),
            callback: () => this.props.navigation.navigate("Devices"),
          },
          // === Users ===
          {
            label: translate("navigation.UserList"),
            icon: faCharCodes.faUsers,
            badge: this.checkBadgeNoAreaUsers(),
            callback: () => this.props.navigation.navigate("Users"),
          },
        ],
      },
      {
        tabItem: [
          // === Scenarios ===
          {
            label: translate("navigation.ScenarioList"),
            icon: faCharCodes.faWandMagic,
            callback: () => this.props.navigation.navigate("Scenarios"),
          },
          // === Parkings ===
          {
            label: translate("navigation.Parkings"),
            icon: faCharCodes.faParking,
            callback: () => this.props.navigation.navigate("Parkings"),
          },
          // === Reservation ===
          {
            label: translate("titleBottomSheet.ORDER_LIST"),
            icon: faCharCodes.faConciergeBell,
            hide:
              this.state.isKioskMode &&
              this.props.AppReducer?.currentBuilding?.modules?.includes(
                CONSTS.MODULES.Reservation
              ),
            callback: () =>
              this.handleOnBottomNavigationTabPress({ key: "ordersList" }),
          },
        ],
      },
      {
        tabItem: [
          // === UserMessages ===
          {
            label: translate("navigation.UserMessages"),
            icon: faCharCodes.faComment,
            badge: this.props.UserMessageReducer.newUserMessages > 0,
            badgeNumber: this.props.UserMessageReducer.newUserMessages,
            callback: () => this.props.navigation.navigate("UserMessages"),
          },
          // === AboutUs ===
          {
            label: translate("navigation.AboutUs"),
            hide: CONSTANTS.BRANDING.NAME_EN === "TapLife",
            icon: faCharCodes.faInfo,
            callback: () => this.props.navigation.navigate("AboutUs"),
          },
        ],
      },
      {
        tabItem: [
          // === Refresh ===
          {
            label: translate("app.refresh"),
            hide: this.state.isKioskMode,
            icon: faCharCodes.faRedoAlt,
            callback: () =>
              this.refreshData(
                this.props.AppReducer?.currentBuilding?.buildingId
              ),
          },
        ],
      },
    ];
    let _AreasToRender = [];
    let closeIconSize = 28;

    let lowBatteriesCount =
      this.props.DeviceReducer.list.filter(
        (d) => d.batteryLevel != null && d.batteryLevel < WARNING_MIN_BATTERY
      ).length || 0;

    for (var a in this.props.AreaReducer.areas) {
      let area = this.props.AreaReducer.areas[a];

      if (!area.showOnHomeScreen) continue;

      var areaDevices = this.props.DeviceReducer.list.filter(
        (d) =>
          area.uDevices?.includes(d.deviceUId) ||
          area.devices?.includes(d.deviceId)
      );
      var model = new AreaModel(area, areaDevices);
      _AreasToRender.push(model);
    }

    return (
      <View
        style={{
          flex: 1,
        }}
        ref={this.ref}
      >
        {this.state.showMenuDrawer && !this.state.isKioskMode && (
          <MenuDrawer
            navigation={this.props.navigation}
            tabs={Tabs}
            onClose={() => {
              this.setState({ showMenuDrawer: false });
            }}
            buildingName={
              this.props.AppReducer?.currentBuilding?.buildingName || ""
            }
            userFullName={
              this.props.AppReducer?.currentServer?.userFullName || ""
            }
          />
        )}
        {/* call elevator  */}
        {this.state.showModalForElevator && (
          <ModalBase
            avoidKeyboard={true}
            isOpen={this.state.showModalForElevator}
            onClose={this.closeElevatorModal}
            contentStyle={{ height: "100%" }}
          >
            <ElevatorPanel
              elevatorDeviceId={this.state.selectedElevator}
              elevatorDeviceUId={this.state.selectedElevatorUId}
            />
          </ModalBase>
        )}
        <View style={{ flexDirection: "row", flex: 1 }}>
          <View style={{ flexDirection: "row", flex: 1 }}>
            {/* === Right MenuBar (Kiosk Mode) === */}
            {this.state.isKioskMode && (
              <View
                style={{
                  backgroundColor: Theme.COLORS.SECONDARY,
                  width: WIDTH / 3.8,
                  paddingHorizontal: 15,
                  paddingTop: 20,
                  maxWidth: 370,
                }}
              >
                {/* === Logo === */}
                <Center mb={2}>
                  <Image
                    width={typeLogoWidth / 2}
                    height={typeLogoHeight / 2}
                    style={{
                      width: typeLogoWidth / 2,
                      height: typeLogoHeight / 2,
                      resizeMode: "contain",
                    }}
                    source={CONSTANTS.BRANDING.LOGO_TYPE}
                  />
                </Center>
                {/* === Header MenuBar === */}
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginBottom: 5,
                  }}
                >
                  {/* === Building name and User Name === === */}
                  <VStack
                    space="1"
                    style={{
                      paddingHorizontal: 10,
                    }}
                  >
                    <Text
                      style={{
                        fontWeight: "bold",
                        fontSize: 16,
                        color: Theme.COLORS.BLACK,
                      }}
                    >
                      {this.props.AppReducer?.currentBuilding?.buildingName}
                    </Text>
                    {this.props.AppReducer?.currentServer?.userFullName &&
                      this.props.AppReducer?.currentServer?.userFullName
                        .length !== "" && (
                        <Text
                          style={{
                            fontWeight: "bold",
                            fontSize: 11,
                            color: Theme.COLORS.GRAY_DARK,
                            textAlign: getIsRTL() ? "right" : "left",
                          }}
                        >
                          {this.props.AppReducer?.currentServer?.userFullName}
                        </Text>
                      )}
                  </VStack>

                  {/* === Building Switch === */}
                  <IconButton
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: 20,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onPress={() => this.onBuildingProfile()}
                    icon={{
                      code: faCharCodes.faBuilding,
                      style: {
                        fontFamily: "FontAwesomeProLight",
                        fontSize: 20,
                        color: Theme.COLORS.MUTED,
                      },
                    }}
                  />
                </View>
                {/* === Weather === */}
                {/* <Weather /> */}
                <View>
                  <ShortcutBoard
                    navigation={this.props.navigation}
                    onShowUnlockDoorLockAlert={(deviceId, deviceUId) =>
                      this.showUnlockDoorConfirm(deviceId, deviceUId)
                    }
                    onTurnOffSiren={(sirenId, sirenUId, sirenName) =>
                      this.showTurnOnSirenConfirm(
                        null,
                        null,
                        sirenId,
                        sirenUId,
                        sirenName,
                        false
                      )
                    }
                    onChangeAreaStateConfirm={(
                      stateId,
                      stateUId,
                      stateName,
                      action
                    ) =>
                      this.showChangeAreaStateConfirm(
                        stateId,
                        stateUId,
                        stateName,
                        action
                      )
                    }
                  />
                  {/* === Announcement Kiosk === */}
                  {this.state.isKioskMode && this.renderAnnouncement()}
                  {lowBatteriesCount > 0 && (
                    <LowBatteryMessage
                      count={lowBatteriesCount}
                      style={[
                        { marginTop: 15, marginBottom: 5 },
                        styles.iosCenter,
                      ]}
                      onButtonPress={() => {
                        this.props.navigation.navigate("Devices", {
                          deviceTypeFilter: DeviceTypes.BATTERY,
                        });
                      }}
                    />
                  )}
                  <WidgetContainer
                    onAction={(widget, action) => {
                      switch (widget) {
                        case CONSTS.WIDGETS.USER_BALANCE:
                          switch (action) {
                            case CONSTS.WIDGET_ACTIONS.RECHARGE:
                              this.props.navigation.navigate("IncreaseCredit");
                          }
                      }
                    }}
                  />
                  {/* === Under Line === */}
                  {/* <UnderLine /> */}
                  <Divider my="2.5" />
                </View>

                {/* === Area Section === */}
                <ScrollView
                  style={{ flex: 4 }}
                  showsVerticalScrollIndicator={true}
                >
                  <MenuBarSectionComponents
                    title={translate("navigation.AreasList")}
                    addHandler={() => {
                      this.props.navigation.navigate("Areas");
                    }}
                  >
                    <ScrollView
                      showsVerticalScrollIndicator={false}
                      contentContainerStyle={{ flex: 1 }}
                    >
                      {_AreasToRender.length == 0 &&
                        this.state.waitingForAreaToLoad && (
                          <View>
                            <AreaKioskItemSkeleton />
                            <AreaKioskItemSkeleton />
                          </View>
                        )}
                      {_AreasToRender.map((ma, i) => {
                        return (
                          <AreaKiosk
                            key={ma.areaId}
                            ref={(ref) => {
                              if (
                                !this.AreasRef.some(
                                  (a) => a.areaId == ma.areaId
                                )
                              ) {
                                this.AreasRef.push({
                                  areaId: ma.areaId,
                                  ref: ref,
                                });
                              }
                            }}
                            // === active Item - MenuBar-Kiosk ===
                            onSelectItemAreaList={() => {
                              this.setState({
                                selectAreaItem: ma.areaId,
                              });
                            }}
                            onSelectItemFirstLoad={() => {
                              this.setState({
                                selectAreaItem: _AreasToRender[0].areaId,
                              });
                            }}
                            isKioskMode={this.state.isKioskMode}
                            selectedId={this.state.selectAreaItem}
                            expanded={_AreasToRender.length <= 3 || i == 0}
                            isArmable={ma.isArmable}
                            areaName={ma.areaName}
                            areaId={ma.areaId}
                            areaUId={ma.areaUId}
                            isArmed={ma.isArmed}
                            isBreached={ma.isBreached}
                            lights={ma.lights}
                            sirens={ma.sirens}
                            blinds={ma.blinds}
                            accessControls={ma.accessControls}
                            hvacs={ma.hvacs}
                            showAreaState={ma.hasPublicAreaState && !ma.isArmed}
                            userDefinedStates={ma.userDefinedStates}
                            cameras={ma.cameras}
                            locks={ma.locks}
                            armReport={ma.armReport}
                            relatedAreaWaterMeterId={ma.relatedAreaWaterMeterId}
                            OnPressAreaStateIcon={(userState) => {
                              this.changeAreaState(userState);
                            }}
                            onAreaItemPress={(areaId, areaUId, deviceType) => {
                              if (this.state.selectedAreaId !== areaId) {
                                this.setState(
                                  {
                                    selectAreaItem: areaId,
                                  },
                                  () => {
                                    this.handleOnAreaItemPress(
                                      areaId,
                                      areaUId,
                                      ma.areaName,
                                      deviceType
                                    );
                                  }
                                );
                              } else {
                                this.handleOnAreaItemPress(
                                  areaId,
                                  areaUId,
                                  ma.areaName,
                                  deviceType
                                );
                              }
                            }}
                            onShowAreaStateRBSheet={() => {
                              this.setState({
                                selectedArea: ma,
                              });
                              this.showActiveModal("areaState");
                            }}
                          />
                        );
                      })}
                      {_AreasToRender.length == 0 &&
                        !this.props.AreaReducer.isLoading &&
                        !this.state.waitingForAreaToLoad && (
                          <View style={{ alignItems: "center", marginTop: 5 }}>
                            <Text
                              style={{
                                textAlign: "center",
                                color: Theme.COLORS.MUTED,
                                fontWeight: "bold",
                                fontSize: 14,
                              }}
                            >
                              {translate("app.emptyList")}
                            </Text>
                          </View>
                        )}
                    </ScrollView>
                  </MenuBarSectionComponents>
                </ScrollView>
                <Divider my="2.5" />

                {/* === Acknowledgments === */}
                {this.props.DeviceReducer.accessControlAcknowledgements.length >
                  0 && (
                  <ScrollView
                    style={{ flex: 2 }}
                    showsVerticalScrollIndicator={true}
                  >
                    {this.props.DeviceReducer.accessControlAcknowledgements.map(
                      (ma, i) => {
                        return (
                          <TouchableOpacity
                            onPress={() =>
                              this.showAccessControlAcknowledgement(
                                ma.id,
                                ma.deviceName,
                                ma.eventCode,
                                ma.persianDate
                              )
                            }
                            key={ma.id}
                            style={{
                              borderRadius: 5,
                              padding: 5,
                              paddingVertical: 5,
                              marginBottom: 5,
                              paddingLeft: 0,
                              width: "95%",
                              backgroundColor: Theme.COLORS.ORANGE,
                            }}
                          >
                            <View>
                              <Text
                                numberOfLines={1}
                                style={{
                                  fontSize: 12,
                                  marginHorizontal: 3,
                                  direction: getDir(),
                                  flex: 1,
                                }}
                              >
                                {ma.deviceName} |{" "}
                                {translate(`deviceLog.${ma.eventCode}`)}
                              </Text>
                            </View>
                          </TouchableOpacity>
                        );
                      }
                    )}
                  </ScrollView>
                )}
              </View>
            )}
            {/* === Left panel === */}
            <View style={{ flex: 1, width: WIDTH / 4.5, position: "relative" }}>
              <ScrollView
                refreshControl={
                  IS_WEB ? undefined : !this.state.isKioskMode ? (
                    <RefreshControl
                      refreshing={this.state.isRefreshing}
                      colors={[Theme.COLORS.TL_PURPLE]}
                      onRefresh={() => {
                        var buildingId =
                          this.props.AppReducer?.currentBuilding?.buildingId;
                        this.refreshData(buildingId);
                      }}
                    />
                  ) : undefined
                }
                scrollEnabled={!this.state.isKioskMode}
                style={
                  !this.state.isKioskMode && {
                    paddingHorizontal: 15,
                  }
                }
              >
                {!this.state.isKioskMode && (
                  <View>
                    {/* === Logo === */}
                    <SafeAreaView
                      style={{
                        alignItems: "center",
                        paddingTop: IS_WEB ? 18 : HEIGHT_STATUS_BAR,
                      }}
                    >
                      <Image
                        width={typeLogoWidth}
                        height={typeLogoHeight}
                        style={{
                          width: typeLogoWidth,
                          height: typeLogoHeight,
                          resizeMode: "contain",
                        }}
                        source={CONSTANTS.BRANDING.LOGO_TYPE}
                      />
                    </SafeAreaView>
                    {/* === Header === */}
                    {!this.state.isKioskMode && (
                      <View
                        style={[
                          {
                            flexDirection: "row",
                            alignItems: "center",
                            height: 55,
                            justifyContent: "space-between",
                            marginTop: 10,
                            maxWidth: "100%",
                            paddingHorizontal: 10,
                            borderRadius: 5,
                            backgroundColor: Theme.COLORS.WHITE,
                          },
                          styles.iosCenter,
                        ]}
                      >
                        {/* === Switch Account === */}
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <View style={{ position: "relative" }}>
                            <IconButton
                              style={{
                                width: 40,
                                height: 40,
                                borderRadius: 20,
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                              onPress={() =>
                                this.props.navigation.navigate("UserMessages")
                              }
                              icon={{
                                code: "\uf0f3",
                                style: {
                                  fontFamily: "FontAwesomeProLight",
                                  fontSize: 20,
                                  color: Theme.COLORS.MUTED,
                                },
                              }}
                            />

                            {this.props.UserMessageReducer.newUserMessages >
                              0 && (
                              <Badge
                                style={{
                                  minWidth: 7,
                                  height: 7,
                                  minHeight: 7,
                                  position: "absolute",
                                  right: 12,
                                  top: 9,
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              ></Badge>
                            )}
                          </View>
                          <Text
                            style={{
                              fontWeight: "bold",
                              fontSize: 20,
                              color: Theme.COLORS.MUTED,
                            }}
                          >
                            {this.props.AppReducer?.currentBuilding
                              ?.buildingName || ""}
                          </Text>
                        </View>
                        <IconButton
                          style={{
                            width: 40,
                            height: 40,
                            borderRadius: 20,
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: Theme.COLORS.SECONDARY,
                            shadowColor: "#000",
                            shadowOffset: {
                              width: 0,
                              height: 2,
                            },
                            shadowOpacity: 0.23,
                            shadowRadius: 2.62,
                            elevation: 5,
                          }}
                          onPress={() => this.onBuildingProfile()}
                          icon={{
                            code: faCharCodes.faBuilding,
                            style: {
                              fontFamily: "FontAwesomeProLight",
                              fontSize: 20,
                              color: Theme.COLORS.MUTED,
                            },
                          }}
                        />
                      </View>
                    )}
                    {/* === Shortcut Board === */}
                    <ShortcutBoard
                      navigation={this.props.navigation}
                      onShowUnlockDoorLockAlert={(deviceId, deviceUId) =>
                        this.showUnlockDoorConfirm(deviceId, deviceUId)
                      }
                      onTurnOffSiren={(sirenId, sirenUId, sirenName) =>
                        this.showTurnOnSirenConfirm(
                          null,
                          null,
                          sirenId,
                          sirenUId,
                          sirenName,
                          false
                        )
                      }
                      onChangeAreaStateConfirm={(
                        stateId,
                        stateUId,
                        stateName,
                        action
                      ) =>
                        this.showChangeAreaStateConfirm(
                          stateId,
                          stateUId,
                          stateName,
                          action
                        )
                      }
                    />
                    {/* === Announcement Mobile === */}
                    {!this.state.isKioskMode && this.renderAnnouncement()}
                    {lowBatteriesCount > 0 && (
                      <LowBatteryMessage
                        count={lowBatteriesCount}
                        style={[
                          { marginTop: 15, marginBottom: 5 },
                          styles.iosCenter,
                        ]}
                        onButtonPress={() => {
                          this.props.navigation.navigate("Devices", {
                            deviceTypeFilter: DeviceTypes.BATTERY,
                          });
                        }}
                      />
                    )}
                    <WidgetContainer
                      onAction={(widget, action) => {
                        switch (widget) {
                          case CONSTS.WIDGETS.USER_BALANCE:
                            switch (action) {
                              case CONSTS.WIDGET_ACTIONS.RECHARGE:
                                this.props.navigation.navigate(
                                  "IncreaseCredit"
                                );
                            }
                        }
                      }}
                    />
                  </View>
                )}
                {/* main areas list */}
                <View>
                  {_AreasToRender.length == 0 &&
                    this.state.waitingForAreaToLoad && (
                      <View style={{ marginTop: 10 }}>
                        <AreaItemSkeleton
                          isKioskMode={this.state.isKioskMode}
                        />
                      </View>
                    )}
                  {_AreasToRender.length == 0 &&
                    this.props.AppReducer?.buildings.length !== 0 &&
                    !this.props.AreaReducer.isLoading &&
                    !this.state.waitingForAreaToLoad && (
                      <View style={{ paddingHorizontal: 15 }}>
                        <MessageBox>
                          {translate("app.noAreaAccessYet")}
                        </MessageBox>
                      </View>
                    )}
                  {this.props.AppReducer?.buildings.length == 0 &&
                    _AreasToRender.length == 0 &&
                    !this.props.AreaReducer.isLoading &&
                    !this.state.waitingForAreaToLoad && (
                      <View style={{ paddingHorizontal: 15 }}>
                        <MessageBox
                          icon={faCharCodes.faBuilding}
                          renderButton={this.renderCreateBuildingHandler()}
                        >
                          {translate("app.noBuilding")}
                        </MessageBox>
                      </View>
                    )}
                  {/* === isKioskMode ? filter by selectedArea : show all areaList === */}
                  {this.state.isKioskMode
                    ? _AreasToRender
                        .filter(
                          (area) => area.areaId === this.state.selectAreaItem
                        )
                        .map((ma, i) => {
                          return this.renderArea(ma, _AreasToRender);
                        })
                    : _AreasToRender.map((ma, i) => {
                        return this.renderArea(ma, _AreasToRender, i);
                      })}
                </View>
              </ScrollView>
            </View>
          </View>
          {/* === Menu slide Kiosk === */}
          {this.state.isKioskMode && (
            <Menu tabs={Tabs} navigation={this.props.navigation} />
          )}
        </View>
        {/* === RBSheet === */}
        {!this.state.isKioskMode && (
          <RBSheet
            ref={(ref) => {
              this.RBSheet = ref;
            }}
            isKioskMode={this.state.isKioskMode}
            closeOnDragDown={true}
            closeOnPressMask={true}
            dragFromTopOnly={true}
            height={RB_SHEET_HEIGHT}
            width={RB_SHEET_WIDTH}
            openDuration={250}
            onClose={this.onUnSubscribeToTopicHandler}
            customStyles={{
              container: {
                ...(this.state.isKioskMode
                  ? {
                      height: HEIGHT_W,
                      maxWidth: 370,
                    }
                  : {
                      width: Math.min(WIDTH, CONSTANTS.WEB_MAX_WIDTH),
                      borderTopLeftRadius: 10,
                      borderTopRightRadius: 10,
                    }),
                alignSelf: this.state.isKioskMode ? "flex-end" : "center",
                shadowColor: "#3333",
                shadowRadius: 10,
                shadowOpacity: 1,
                shadowOffset: { height: -10, width: 0 },
                paddingBottom: 20,
              },
              draggableContainer: {
                opacity: this.state.isKioskMode ? 0 : 1,
              },
            }}
          >
            <View
              style={{
                flexDirection: IS_MOBILE ? "row-reverse" : "row",
                justifyContent: "space-between",
                alignItems: "center",
                paddingRight: 10,
                paddingBottom: 5,
                height: RB_SHEET_TITLE_HEIGHT,
              }}
            >
              <IconButton
                onPress={() => {
                  this.closeRBSheetMobileMode();
                  this.setState({ rbSheetTitle: "" });
                }}
                style={{
                  width: 2 * closeIconSize,
                  height: closeIconSize + 2,
                  alignItems: "center",
                  paddingEnd: -5,
                  justifyContent: "center",
                  color: Theme.COLORS.TL_PURPLE,
                }}
                icon={{
                  code: "\uf057",
                  style: {
                    fontFamily: "FontAwesomeProLight",
                    fontSize: closeIconSize,
                    color: Theme.COLORS.GRAY_DARK,
                  },
                }}
              />
              <Text style={styles.bottomSheetItemText}>
                {translate(`titleBottomSheet.${this.state.rbSheetTitle}`)}
              </Text>
            </View>
            {this.renderRBSheetInner()}
          </RBSheet>
        )}
        {/* === Menu Bottom - BottomNavigation === */}
        {!this.state.isKioskMode && (
          <BottomNavigation
            style={[
              {
                height: Platform.OS == "ios" ? 70 : 60,
              },
              this.state.isKioskMode && { width: WIDTH / 3.5 },
            ]}
            activeTab={this.state.activeTab}
            onTabPress={this.handleOnBottomNavigationTabPress}
            renderTab={this.renderTab}
            tabs={[
              {
                key: "buildingProfile",
                hide: true,
                icon: "\uf562",
                size: 20,
                pressColor: "rgba(255, 255, 255, 0)",
              },
              {
                key: "ordersList",
                hide: !this.props.AppReducer?.currentBuilding?.modules?.includes(
                  CONSTS.MODULES.Reservation
                ),
                icon: "\uf562",
                size: 20,
                pressColor: "rgba(255, 255, 255, 0)",
              },
              {
                key: "scenarios",
                hide: this.props.AppReducer?.currentBuilding?.modules?.includes(
                  CONSTS.MODULES.Reservation
                ),
                icon: faCharCodes.faWandMagic,
                size: 20,
                pressColor: "rgba(255, 255, 255, 0)",
              },
              {
                key: "home",
                icon: faCharCodes.faRedoAlt,
                hide: this.state.isKioskMode,
                size: 23,
                barColor: "#fff",
                pressColor: "rgba(255, 255, 255, 0)",
              },
              {
                key: "setting",
                icon: "\uf013",
                size: 20,
                pressColor: "rgba(255, 255, 255, 0)",
              },
              {
                key: "profiles",
                hide: true,
                icon: "\uf013",
                size: 20,
                pressColor: "rgba(255, 255, 255, 0)",
              },
              {
                key: "areaType",
                hide: true,
                icon: "\uf013",
                size: 20,
                barColor: "#fff",
                pressColor: "rgba(255,255,255,0)",
              },
              {
                key: "multiMedia",
                hide: true,
                icon: "\uf013",
                size: 20,
                pressColor: "rgba(255,255,255,0)",
              },
            ]}
          />
        )}
        {/* force logout modal */}
        {this.props.UserReducer.forcedLogoutReceived && (
          <ModalBase
            closeButton={false}
            avoidKeyboard={true}
            isOpen={this.props.UserReducer.forcedLogoutReceived}
            onClose={this.navigateToLogout}
          >
            <View style={{ justifyContent: "center", alignItems: "center" }}>
              <View
                style={{
                  borderRadius: 10,
                  padding: 15,
                  height: 130,
                  width: "100%",
                  margin: "auto",
                }}
              >
                <Text
                  style={{
                    textAlign: "center",
                    fontSize: 14,
                    fontWeight: "bold",
                  }}
                >
                  {this.props.UserReducer.logoutMessage
                    ? translate(
                        `login.errors.${this.props.UserReducer.logoutMessage}`
                      )
                    : translate(`login.errors.AccountDisabled`)}
                </Text>
                <ArButton
                  color="primary"
                  onPress={this.navigateToLogout}
                  style={{ width: "90%", alignSelf: "center", marginTop: 25 }}
                >
                  {translate("app.confirm")}
                </ArButton>
              </View>
            </View>
          </ModalBase>
        )}

        {/* === Modal Join building === */}
        {this.state.showJoinModal && (
          <ModalJoinBuilding
            showJoinModal={this.state.showJoinModal}
            hideModal={() => {
              this.setState({ showJoinModal: false });
              this.hideActiveModal();
            }}
            changeBuilding={async (buildingInfo, serverInfo) => {
              if (buildingInfo) {
                this.props.updateCurrentBuilding(buildingInfo);
                this.refreshData(buildingInfo.buildingId);
              }
            }}
          />
        )}
        {this.state.showQRCodeJoinBuilding && (
          <QRCodeJoinBuilding
            isKioskMode={this.state.isKioskMode}
            showQRCodeJoinBuilding={this.state.showQRCodeJoinBuilding}
            buildingInfo={this.state.selectedJoinBuildingInfo}
            hideModal={() => this.setState({ showQRCodeJoinBuilding: false })}
          />
        )}
        {/* confirm turnOn siren */}
        {this.state.sirenToTurnOn && this.state.sirenToTurnOn.showConfirm && (
          <AlertDialogBase
            isOpen={true}
            title={translate("deviceGroup.siren")}
            confirmText={translate("app.confirm")}
            colorConfirm="primary"
            confirmHandler={() => {
              if (this.state.sirenToTurnOn) {
                let { sirenDeviceUId, sirenDeviceId, areaId, areaUId, value } =
                  this.state.sirenToTurnOn;

                if (sirenDeviceId || sirenDeviceUId) {
                  this.onUpdateSirenValue(
                    null,
                    null,
                    sirenDeviceId,
                    sirenDeviceUId,
                    value
                  );
                } else if (areaId || areaUId) {
                  this.onUpdateSirenValue(areaId, areaUId, null, null, value);
                }
              }
              this.hideTurnOnSirenConfirm();
            }}
            onClose={() => {
              this.hideTurnOnSirenConfirm();
            }}
          >
            <Text>
              {this.state.sirenToTurnOn?.sirenDeviceId ||
              this.state.sirenToTurnOn?.sirenDeviceUId
                ? this.state.sirenToTurnOn.value
                  ? translate("device.confirmTurnOnSiren", {
                      sirenDeviceName:
                        this.state.sirenToTurnOn?.sirenDeviceName || "",
                    })
                  : translate("device.turnOffSiren")
                : translate("device.confirmTurnOnSirens", {
                    areaName: this.state.sirenToTurnOn?.areaName || "",
                  })}
            </Text>
          </AlertDialogBase>
        )}
        {/* === UnLock Door alert from sever === */}
        {(this.props.DeviceReducer.doorToAskOpenDeviceUId != null ||
          this.props.DeviceReducer.doorToAskOpenDeviceId > 0) && (
          <AlertDialogBase
            isOpen={true}
            title={translate("deviceGroup.doorLock")}
            confirmText={translate("app.confirm")}
            colorConfirm="info"
            confirmHandler={() => {
              this.props.unlockDoorLock(
                this.props.DeviceReducer.doorToAskOpenDeviceId,
                this.props.DeviceReducer.doorToAskOpenDeviceUId,
                this.state.accessToken
              );
              this.props.resetAskToOpenDataLocally();
            }}
            onClose={() => {
              this.props.resetAskToOpenDataLocally();
            }}
          >
            <Text>
              {this.props.DeviceReducer.doorToAskOpenDeviceName +
                " " +
                translate("device.openDoor")}
            </Text>
          </AlertDialogBase>
        )}

        {/* === Access Control Notification (Camera) === */}
        {this.props.DeviceReducer.isShowingAccessControlNotification && (
          <ModalBase
            header={
              this.props.DeviceReducer.list.find(
                (d) =>
                  d.deviceUId ==
                  this.props.DeviceReducer.isShowingAccessControlNotification
              ).accessControlCameraTitle
            }
            isOpen={this.props.DeviceReducer.isShowingAccessControlNotification}
            onClose={() =>
              this.hideAccessControlNotification(
                this.props.DeviceReducer.list.find(
                  (d) =>
                    d.deviceUId ==
                    this.props.DeviceReducer.isShowingAccessControlNotification
                ).accessControlCameraProcessId
              )
            }
          >
            <ScrollView
              contentContainerStyle={{
                padding: 5,
                flex: 1,
                justifyContent: "center",
                alignItems: "center",
              }}
              // style={style.modalInsideWrapper}
            >
              <HStack
                mb={1}
                alignItems="flex-end"
                space={1}
                style={{ width: "100%", justifyContent: "center" }}
              >
                <HStack
                  alignItems="center"
                  style={{
                    borderWidth: 1,
                    borderColor: Theme.COLORS.BORDER_COLOR,
                    borderRadius: 10,

                    padding: 2,
                  }}
                >
                  <Text style={{ paddingHorizontal: 5 }}>
                    {translate("app.doorState")}
                    {translate(
                      "app.door" +
                        this.props.DeviceReducer.list.find(
                          (d) =>
                            d.deviceUId ==
                            this.props.DeviceReducer
                              .isShowingAccessControlNotification
                        ).doorState
                    )}
                  </Text>
                  <IconButton
                    icon={{
                      code:
                        this.props.DeviceReducer.list.find(
                          (d) =>
                            d.deviceUId ==
                            this.props.DeviceReducer
                              .isShowingAccessControlNotification
                        ).doorState == "Closed"
                          ? faCharCodes.faDoorClosed
                          : faCharCodes.faDoorOpen,
                      style: {
                        fontFamily: "FontAwesomeProLight",
                        fontSize: 18,
                        color:
                          this.props.DeviceReducer.list.find(
                            (d) =>
                              d.deviceUId ==
                              this.props.DeviceReducer
                                .isShowingAccessControlNotification
                          ).doorState == "ForcedOpen" ||
                          this.props.DeviceReducer.list.find(
                            (d) =>
                              d.deviceUId ==
                              this.props.DeviceReducer
                                .isShowingAccessControlNotification
                          ).doorState == "HeldOpen"
                            ? Theme.COLORS.ERROR
                            : "#666666",
                        padding: 8,
                        // height: 30,
                        borderWidth: 1,
                        borderColor: Theme.COLORS.BORDER_COLOR,
                        borderRadius: 10,
                      },
                    }}
                  />
                </HStack>

                {this.props.DeviceReducer.list.find(
                  (d) =>
                    d.deviceUId ==
                    this.props.DeviceReducer.isShowingAccessControlNotification
                ).accessControlFailedAttemptCount != 0 && (
                  <HStack
                    alignItems="center"
                    style={{
                      borderWidth: 1,
                      borderColor: Theme.COLORS.BORDER_COLOR,
                      borderRadius: 10,
                      padding: 2,
                    }}
                  >
                    <Text style={{ paddingHorizontal: 5 }}>
                      {translate("app.failedAttemptCount")}
                      {
                        this.props.DeviceReducer.list.find(
                          (d) =>
                            d.deviceUId ==
                            this.props.DeviceReducer
                              .isShowingAccessControlNotification
                        ).accessControlFailedAttemptCount
                      }
                    </Text>
                    <IconButton
                      icon={{
                        code: faCharCodes.faExclamationCircle,
                        style: {
                          fontFamily: "FontAwesomeProLight",
                          fontSize: 18,
                          color: "#666666",
                          padding: 8,
                          // height: 30,
                          borderWidth: 1,
                          borderColor: Theme.COLORS.BORDER_COLOR,
                          borderRadius: 10,
                        },
                      }}
                    />
                  </HStack>
                )}
                <HStack
                  alignItems="center"
                  style={{
                    borderWidth: 1,
                    borderColor: Theme.COLORS.BORDER_COLOR,
                    borderRadius: 10,
                    padding: 2,
                  }}
                >
                  <Text style={{ paddingHorizontal: 5 }}>
                    {translate("app.systemLockStatus")}
                  </Text>
                  <IconButton
                    icon={{
                      code:
                        this.props.DeviceReducer.list.find(
                          (d) =>
                            d.deviceUId ==
                            this.props.DeviceReducer
                              .isShowingAccessControlNotification
                        ).isSystemLocked == true
                          ? faCharCodes.faLock
                          : faCharCodes.faLockOpen,
                      style: {
                        fontFamily: "FontAwesomeProLight",
                        fontSize: 18,
                        color:
                          this.props.DeviceReducer.list.find(
                            (d) =>
                              d.deviceUId ==
                              this.props.DeviceReducer
                                .isShowingAccessControlNotification
                          ).isSystemLocked == true
                            ? Theme.COLORS.ERROR
                            : "#666666",
                        padding: 8,
                        // height: 30,
                        borderWidth: 1,
                        borderColor: Theme.COLORS.BORDER_COLOR,
                        borderRadius: 10,
                      },
                    }}
                  />
                </HStack>
              </HStack>
              {this.props.DeviceReducer.list.find(
                (d) =>
                  d.deviceUId ==
                  this.props.DeviceReducer.isShowingAccessControlNotification
              ).accessControlCameraUrl != "" && (
                <HStack
                  alignItems="center"
                  space={1}
                  style={{ width: "100%", justifyContent: "center" }}
                >
                  <Image
                    style={{
                      width:
                        this.props.DeviceReducer.list.find(
                          (d) =>
                            d.deviceUId ==
                            this.props.DeviceReducer
                              .isShowingAccessControlNotification
                        ).accessControlCameraScreenWidth || "85%",
                      height:
                        this.props.DeviceReducer.list.find(
                          (d) =>
                            d.deviceUId ==
                            this.props.DeviceReducer
                              .isShowingAccessControlNotification
                        ).accessControlCameraScreenHeight || undefined,
                      aspectRatio: 1,
                      resizeMode: "contain",
                    }}
                    source={{
                      uri:
                        this.props.DeviceReducer.list.find(
                          (d) =>
                            d.deviceUId ==
                            this.props.DeviceReducer
                              .isShowingAccessControlNotification
                        ).accessControlCameraUrl +
                        `&hash=${
                          this.props.DeviceReducer.list.find(
                            (d) =>
                              d.deviceUId ==
                              this.props.DeviceReducer
                                .isShowingAccessControlNotification
                          ).accessControlCameraProcessId
                        }`,
                      headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${this.state.accessToken}`,
                      },
                    }}
                  />
                </HStack>
              )}
              <HStack alignItems="center" space="2">
                <ArButton
                  color="muted"
                  variant="outline"
                  onPress={() => {
                    this.hideAccessControlNotification(
                      this.props.DeviceReducer.list.find(
                        (d) =>
                          d.deviceUId ==
                          this.props.DeviceReducer
                            .isShowingAccessControlNotification
                      ).accessControlCameraProcessId
                    );
                  }}
                  style={[
                    {
                      ...styles.modalBtn,
                    },
                    { margin: 10 },
                    { width: "100px" },
                  ]}
                >
                  {translate("app.close")}
                </ArButton>
              </HStack>
            </ScrollView>
          </ModalBase>
        )}
        {/* === Confirm Access Control Door Open === */}
        {this.state.isShowingAccessControlOpenDoorConfirm && (
          <AlertDialogBase
            isOpen={this.state.isShowingAccessControlOpenDoorConfirm}
            title={translate("deviceGroup.accessControl")}
            confirmText={translate("app.confirm")}
            colorConfirm="primary"
            confirmHandler={() => {
              if (
                this.state.accessControlToOpenDoorDeviceId ||
                this.state.accessControlToOpenDoorDeviceUId
              ) {
                this.accessControlOpenDoor(
                  this.state.accessControlToOpenDoorDeviceId,
                  this.state.accessControlToOpenDoorDeviceUId
                );
              }
            }}
            onClose={() => this.hideAccessControlOpenDoorConfirm()}
          >
            <Text>{this.state.accessControlToOpenDoorDeviceName}</Text>
            <Text>{translate("device.confirmUnlockDoor")}</Text>
          </AlertDialogBase>
        )}
        {/* === Confirm Access Control All Area Doors Open === */}
        {this.state.isShowingAccessControlOpenAllAreaDoorsConfirm && (
          <AlertDialogBase
            isOpen={this.state.isShowingAccessControlOpenAllAreaDoorsConfirm}
            title={translate("deviceGroup.accessControl")}
            confirmText={translate("app.confirm")}
            colorConfirm="primary"
            confirmHandler={() => {
              if (
                this.state.accessControlToOpenAllDoorsAreaId ||
                this.state.accessControlToOpenAllDoorsAreaUId
              ) {
                this.accessControlOpenAllAreaDoors(
                  this.state.accessControlToOpenAllDoorsAreaId,
                  this.state.accessControlToOpenAllDoorsAreaUId
                );
              }
            }}
            onClose={() => this.hideAccessControlOpenAllAreaDoorsConfirm()}
          >
            <Text>{translate("device.confirmUnlockAllDoor")}</Text>
          </AlertDialogBase>
        )}
        {/* === Access Control Acknowledgement === */}
        {this.state.isShowingAccessControlAcknowledgement && (
          <AlertDialogBase
            isOpen={this.state.isShowingAccessControlAcknowledgement}
            title={translate("deviceGroup.accessControl")}
            confirmText={translate("app.confirm")}
            colorConfirm="primary"
            confirmHandler={() => {
              this.accessControlConfirmAcknowledgement(
                this.state.accessControlAcknowledgementToConfirmEventId
              );
            }}
            onClose={() => this.hideAccessControlAcknowledgement()}
          >
            <Text>
              {translate("device.deviceName")}:{" "}
              {this.state.accessControlAcknowledgementToConfirmDeviceName}
            </Text>
            <Text>
              {translate("deviceLog.event")}:{" "}
              {translate(
                `deviceLog.${this.state.accessControlAcknowledgementToConfirmEventCode}`
              )}
            </Text>
            <Text>
              {translate("app.date")}:{" "}
              <span dir="ltr">
                {this.state.accessControlAcknowledgementToConfirmPersianDate}
              </span>
            </Text>
          </AlertDialogBase>
        )}

        {/* === User Sessions Warning === */}
        {(this.props.UserReducer.sessions?.length > 1 ) && this.state.isShowingUserSessionsWarning && (
          <AlertDialogBase
            isOpen={this.state.isShowingUserSessionsWarning}
            title={translate("app.userSessionsWarningTitle")}
            cancelText={translate("app.confirm")}
            colorConfirm="error"
            // confirmHandler={() => this.hideUserSessionsWarning()}
            onClose={() => this.hideUserSessionsWarning()}
          >
            <Text>{translate("app.userSessionsWarning1")}</Text>
            <Text>{translate("app.userSessionsWarning2")}</Text>
          </AlertDialogBase>
        )}

        {/* === Area State alert === */}
        {this.state.isShowChangeAreaStateConfirm && (
          <AlertDialogBase
            isOpen={this.state.isShowChangeAreaStateConfirm}
            title={translate("v2Dashboard.changeUserDefinedState")}
            confirmText={translate("app.confirm")}
            colorConfirm="primary"
            confirmHandler={() => {
              if (this.state.areaStateActionToChange == "activate") {
                this.props.activateState(
                  this.state.areaStateIdToChange,
                  this.state.areaStateUIdToChange,
                  this.state.accessToken
                );
              } else if (this.state.areaStateActionToChange == "deActivate") {
                this.props.deActivateState(
                  this.state.areaStateIdToChange,
                  this.state.areaStateUIdToChange,
                  this.state.accessToken
                );
              }
              this.hideChangeAreaStateConfirm();
            }}
            onClose={() => this.hideChangeAreaStateConfirm()}
          >
            <Text>
              {translate("areaState.areaStateChangeMessage", {
                stateName: this.state.areaStateNameToChange,
                action:
                  this.state.areaStateActionToChange == "activate"
                    ? translate("areaState.active")
                    : translate("areaState.deActive"),
              })}
            </Text>
          </AlertDialogBase>
        )}
        {/* === UnLock Door alert === */}
        {this.state.isShowingUnlockDoorAlert && (
          <AlertDialogBase
            isOpen={this.state.isShowingUnlockDoorAlert}
            title={translate("deviceGroup.doorLock")}
            confirmText={translate("app.confirm")}
            colorConfirm="primary"
            confirmHandler={() => {
              if (
                this.state.doorToUnlockDeviceId ||
                this.state.doorToUnlockDeviceUId
              ) {
                this.onUnlockDoorLock(
                  this.state.doorToUnlockDeviceId,
                  this.state.doorToUnlockDeviceUId
                );
              }
            }}
            onClose={() => this.hideUnlockDoorConfirm()}
          >
            <Text>{translate("device.confirmUnlockDoor")}</Text>
          </AlertDialogBase>
        )}
        {/* confirm delete playlist */}
        {(this.state.playListIdToDelete > 0 ||
          this.state.playListUIdToDelete) && (
          <AlertDialogBase
            isOpen={true}
            confirmText={translate("app.confirm")}
            colorConfirm="error"
            confirmHandler={() => {
              this.props.deletePlaylist(
                this.state.playListIdToDelete,
                this.state.playListUIdToDelete,
                this.state.accessToken
              );
              this.hideDeletePlaylistConfirm();
            }}
            onClose={() => this.hideDeletePlaylistConfirm()}
          >
            <Text>
              {translate("device.confirmDeletePlayList", {
                title: this.state.playListTitleToDelete,
              })}
            </Text>
          </AlertDialogBase>
        )}
        {/* === active Modal === */}
        {this.state.activeModal && (
          <ModalBase
            header={translate(
              `titleBottomSheet.${this.state.activeModalTitle}`
            )}
            isOpen={true}
            onClose={() => this.hideActiveModal()}
            contentStyle={{ minHeight: "40%" }}
          >
            {this.renderActiveModal()}
          </ModalBase>
        )}
        {/* === Touch Panel Enter Code Form === */}
        {this.props.AreaReducer?.touchPanelAlert && (
          <Modal
            style={{ direction: getDir() }}
            isOpen={true}
            justifyContent="center"
            alignItems="center"
          >
            <Modal.Content
              w="full"
              maxWidth={{ base: "90%", md: "50%" }}
              maxHeight="80%"
              // height="100%"
              // {...contentStyle}
            >
              <Modal.Body p={0}>
                <PinCodeArm
                  accessToken={this.props.AppReducer.currentServer?.accessToken}
                  buildingId={
                    this.props.AppReducer?.currentBuilding?.buildingId
                  }
                  serverUrl={this.props.AppReducer?.serverUrl}
                  content={this.props.AreaReducer.touchPanelAlert}
                  callback={() => this.props.clearTouchPanelAlert()}
                  toastMessageCallback={(message) =>
                    this.props.messageToast(message)
                  }
                />
              </Modal.Body>
            </Modal.Content>
          </Modal>
        )}
      </View>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    DeviceReducer: state.DeviceReducer,
    AreaReducer: state.AreaReducer,
    UserReducer: state.UserReducer,
    AppReducer: state.AppReducer,
    ScenarioReducer: state.ScenarioReducer,
    UserMessageReducer: state.UserMessageReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // === Kiosk Mode ===
    updateKioskMode: (isKioskMode) => {
      dispatch(AppActions.updateKioskMode(isKioskMode));
    },
    // lights
    updateLightValue: (deviceId, deviceUId, newValue, accessToken) => {
      if (newValue) {
        dispatch(LightActions.turnOn(deviceId, deviceUId, accessToken));
      } else {
        dispatch(LightActions.turnOff(deviceId, deviceUId, accessToken));
      }
    },
    activateState: (stateId, stateUId, accessToken) => {
      dispatch(AreaActions.ActivateState(stateId, stateUId, accessToken));
    },
    deActivateState: (stateId, stateUId, accessToken) =>
      dispatch(AreaActions.DeActivateState(stateId, stateUId, accessToken)),
    updateAllLightsValue: (areaId, areaUId, newValue, accessToken) =>
      dispatch(
        AreaActions.changeLights(areaId, areaUId, newValue, accessToken)
      ),
    // power switches
    updatePowerSwitchValue: (deviceId, deviceUId, newValue, accessToken) => {
      if (newValue) {
        dispatch(PowerSwitchActions.turnOn(deviceId, deviceUId, accessToken));
      } else {
        dispatch(PowerSwitchActions.turnOff(deviceId, deviceUId, accessToken));
      }
    },
    updateAllPowerSwitchesValue: (areaId, areaUId, newValue, accessToken) =>
      dispatch(
        AreaActions.changePowerSwitches(areaId, areaUId, newValue, accessToken)
      ),

    // elevators
    subscribeToTopic: (topic, accessToken) =>
      dispatch(ElevatorsAction.SubscribeToTopic(topic, accessToken)),
    unSubscribeToTopic: (topic, accessToken) =>
      dispatch(ElevatorsAction.UnSubscribeToTopic(topic, accessToken)),

    // watering switches
    updateWateringSwitchValue: (deviceId, deviceUId, newValue, accessToken) => {
      if (newValue) {
        dispatch(WateringSwitchAction.turnOn(deviceId, deviceUId, accessToken));
      } else {
        dispatch(
          WateringSwitchAction.turnOff(deviceId, deviceUId, accessToken)
        );
      }
    },
    updateAllWateringSwitchesValue: (areaId, areaUId, newValue, accessToken) =>
      dispatch(
        AreaActions.changeWateringSwitches(
          areaId,
          areaUId,
          newValue,
          accessToken
        )
      ),

    // outlets
    updateOutletValue: (deviceId, deviceUId, newValue, accessToken) => {
      if (newValue) {
        dispatch(OutletActions.turnOn(deviceId, deviceUId, accessToken));
      } else {
        dispatch(OutletActions.turnOff(deviceId, deviceUId, accessToken));
      }
    },
    updateAllOutletsValue: (areaId, areaUId, newValue, accessToken) =>
      dispatch(
        AreaActions.changeOutlets(areaId, areaUId, newValue, accessToken)
      ),

    // sirens
    updateSirenValue: (deviceId, deviceUId, newValue, accessToken) => {
      if (newValue) {
        dispatch(SirenActions.turnOn(deviceId, deviceUId, accessToken));
      } else {
        dispatch(SirenActions.turnOff(deviceId, deviceUId, accessToken));
      }
    },
    updateAllSirensValue: (areaId, deviceUId, newValue, accessToken) =>
      dispatch(
        AreaActions.changeSirens(areaId, deviceUId, newValue, accessToken)
      ),

    // airConditioners
    updateAirConditionerValue: (deviceId, deviceUId, newValue, accessToken) => {
      if (newValue) {
        dispatch(
          AirConditionerActions.turnOn(deviceId, deviceUId, accessToken)
        );
      } else {
        dispatch(
          AirConditionerActions.turnOff(deviceId, deviceUId, accessToken)
        );
      }
    },
    updateAllAirConditionersValue: (areaId, areaUId, newValue, accessToken) =>
      dispatch(AreaActions.changeHVACs(areaId, areaUId, newValue, accessToken)),

    updateAirConditionerSetPoint: (
      deviceId,
      deviceUId,
      setPointValue,
      accessToken
    ) =>
      dispatch(
        AirConditionerActions.changeSetPoint(
          deviceId,
          deviceUId,
          setPointValue,
          accessToken
        )
      ),
    updateAirConditionerFanMode: (deviceId, deviceUId, mode, accessToken) =>
      dispatch(
        AirConditionerActions.changeThermostatFanMode(
          deviceId,
          deviceUId,
          mode,
          accessToken
        )
      ),
    updateAirConditionerMode: (
      deviceId,
      deviceUId,
      mode,
      economy,
      accessToken
    ) =>
      dispatch(
        AirConditionerActions.changeThermostatMode(
          deviceId,
          deviceUId,
          mode,
          economy,
          accessToken
        )
      ),
    // curtains
    updateCurtainValue: (deviceId, deviceUId, newValue, accessToken) => {
      dispatch(
        CurtainActions.ChangeValueLocallyTo(deviceId, deviceUId, newValue)
      );
      dispatch(
        CurtainActions.ChangeValueTo(deviceId, deviceUId, newValue, accessToken)
      );
    },

    // doorLocks
    lockDoorLock: (deviceId, deviceUId, accessToken) =>
      dispatch(DoorlockActions.Lock(deviceId, deviceUId, accessToken)),
    unlockDoorLock: (deviceId, deviceUId, accessToken) =>
      dispatch(DoorlockActions.Unlock(deviceId, deviceUId, accessToken)),
    resetAskToOpenDataLocally: () =>
      dispatch(DoorlockActions.resetAskToOpenDataLocally()),

    // accessControl
    accessControlOpenDoor: (deviceId, deviceUId, accessToken) =>
      dispatch(AccessControlActions.OpenDoor(deviceId, deviceUId, accessToken)),
    accessControlOpenAllAreaDoors: (areaId, areaUId, accessToken) =>
      dispatch(
        AreaActions.openAllAccessControlDoors(areaId, areaUId, accessToken)
      ),
    accessControlRequestNotification: (deviceId, deviceUId, accessToken) =>
      dispatch(
        AccessControlActions.RequestNotification(
          deviceId,
          deviceUId,
          accessToken
        )
      ),
    accessControlClosetCamera: (processId, accessToken) =>
      dispatch(AccessControlActions.CloseCamera(processId, accessToken)),
    accessControlConfirmAcknowledgement: (eventId, accessToken) =>
      dispatch(
        AccessControlActions.ConfirmAcknowledgement(eventId, accessToken)
      ),
    accessControlToggleSystemLock: (deviceId, deviceUId, accessToken) =>
      dispatch(
        AccessControlActions.ToggleSystemLock(deviceId, deviceUId, accessToken)
      ),
    // motion detections
    restoreMotionDetection: (deviceId) => {
      dispatch(DeviceActions.RestoreMotionDetectionLocally(deviceId));
    },

    // quick access cache
    setScenariosFromCache: (scenarios) =>
      dispatch(AppActions.SetScenariosFromCache(scenarios)),
    // multimedia
    getAllPlaylists: (accessToken) =>
      dispatch(DeviceActions.GetAllPlaylists(accessToken)),
    deletePlaylist: (id, uId, accessToken) =>
      dispatch(DeviceActions.DeletePlaylist(id, uId, accessToken)),
    playSpeaker: (
      areaId,
      areaUId,
      deviceId,
      deviceUId,
      playListId,
      playListUId,
      trackId,
      accessToken
    ) =>
      dispatch(
        SmartSpeakerActions.Play(
          areaId,
          areaUId,
          deviceId,
          deviceUId,
          playListId,
          playListUId,
          trackId,
          accessToken
        )
      ),

    // other
    resetLogoutToggle: () => dispatch(UserActions.ResetLogoutToggle()),
    forceInit: (accessToken, buildingId) =>
      dispatch(AppActions.ForceInit(accessToken, buildingId)),
    areaCache: (areas) => dispatch(AreaActions.AreaCache(areas)),
    logout: () => dispatch(AppActions.LogOut()),
    reconnect: (newServerUrl) =>
      dispatch(AppActions.ResetConnection(newServerUrl)),
    setBuildings: (buildingInfo) => {
      dispatch(AppActions.setBuildings(buildingInfo));
    },
    setServers: (serversInfo) => {
      dispatch(AppActions.setServers(serversInfo));
    },
    // === message toast ===
    messageToast: (message) => {
      dispatch(AppActions.messageToast(message));
    },
    clearCache: () => dispatch(AppActions.clearCache()),
    updateCurrentServer: (serverInfo) => {
      dispatch(AppActions.updateCurrentServer(serverInfo));
    },
    updateCurrentBuilding: (buildingInfo) => {
      dispatch(AppActions.updateCurrentBuilding(buildingInfo));
    },
    dispatch: (action) => {
      dispatch(action);
    },
    // === Widget ===
    appWidgetAnnouncement: (accessToken) => {
      dispatch(AppActions.appWidgetAnnouncement(accessToken));
    },
    clearAnnouncement: () => {
      dispatch(AppActions.clearAnnouncement());
    },
    // === Update ServerUrl ===
    updateServerUrl: (serverUrl) => {
      dispatch(AppActions.updateServerUrl(serverUrl));
    },
    // === Touch Panel ===
    clearTouchPanelAlert: () => {
      dispatch(AreaActions.clearTouchPanelAlert());
    },
  };
};

const styles = StyleSheet.create({
  bottomSheetItemText: {
    fontSize: 20,
    color: Theme.COLORS.GRAY_DARK, //"#666666",
    paddingTop: 5,
    paddingBottom: 5,
    flex: 1,
  },
  iosCenter: {
    marginStart: Platform.OS == "ios" ? 15 : 0,
  },
  modalBtn: {
    flex: 1,
    height: 40,
    marginBottom: 0,
    alignSelf: "center",
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(HomeScreen);
